import {
  ActionIcon,
  Alert,
  Anchor,
  Avatar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Col,
  Container,
  Divider,
  Flex,
  Grid,
  Group,
  Modal,
  NumberInput,
  Select,
  Table,
  Text,
  TextInput,
  Tooltip,
  Card,
  Stack,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { getHotkeyHandler, useForceUpdate, useMediaQuery } from "@mantine/hooks";
import {
  IconAlertCircle,
  IconClearAll,
  IconDiscount2,
  IconFile,
  IconFileInvoice,
  IconId,
  IconPrinter,
  IconSearch,
  IconSquareMinus,
  IconSquareRoundedMinus,
  IconTag,
  IconX,
  IconEdit,
  IconCheck,
} from "@tabler/icons";
import AddPaymentReceipt from "components/AddPaymentReceipt";
import CouponsModal from "components/CouponsModal";
import CustomerSelection from "components/CustomerSelection";
import printTemplate from "components/InvoicePrintComponent";
import PaymentReceiptModal from "components/PaymentReceiptModal";
import produce, { current } from "immer";
import moment from "moment";
import { coupons_api } from "pages/master/coupons/coupons.service";
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";


import { constructInvoiceItem, getModifiedList } from "./InvoiceHelperFunctions";
import { invoice_api } from "./invoice.service";
import { showErrorToast, showSuccessToast } from "../../../utilities/Toast";
import { api_addPaymentReceipt } from "../payment-receipt/paymentReceipt.service";

export default function InvoiceMaster() {
  const batchTable = React.useRef("");
  const forceUpdate = useForceUpdate();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let isMobileScreen = useMediaQuery("(max-width: 768px)");
  const location = useLocation();

  // STARTS : States
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [productSelectionModal, setProductSelectionModal] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [productsSearchList, setProductsSearchList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [deletedItems, setDeletedItems] = useState([]);

  // const [selectedBatchProductCode, setSelectedBatchProductCode] = useState(null);
  const [modalBatches, setModalBatches] = useState([]);
  const [currentBatch, setCurrentBatch] = useState({});
  // ENDS : States

  // Invoice states
  const [invoiceItemsList, setInvoiceItemsList] = useState([]);
  const [batches, setBatches] = useState([]);
  const [netDiscount, setNetDiscount] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [invoiceTotal, setInvoiceTotal] = useState(null);
  const [payAndPrintBill, setPayAndPrintBill] = useState(false)
  // Ends : Invoice states

  const [focusSearch, setfocusSearch] = useState(location.pathname.includes("edit"));

  // STARTS : States

  const [discFocus, setDiscFocus] = useState(false);
  const [focus, setFocus] = useState(false);
  const [paymentReceiptFormVisible, setPaymentReceiptFormVisible] = useState(false);
  const [invoicesData, setInvoicesData] = useState([]);
  const [invoicesId, setInvoicesId] = useState(null);
  const [mobileNumberErrorMessage, setMobileNumberErrorMessage] = useState("");
  const [packingCharge, setPackingCharge] = useState(0);
  const [loading, setLoading] = useState(false); 

  const [couponsModalOpened, setCouponsModalOpened] = useState(false);
  const [couponCode, setCouponCode] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [couponApplied, setCouponApplied] = useState({});
  const [customers, setCustomers] = useState([]);
  const [customerSelected, setCustomerSelected] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [lockFocus, setLockFocus] = useState(false);

  // ENDS : States
const [selectedRow, setSelectedRow] = useState(null);
const [isListFocused, setIsListFocused] = useState(false);
  //

  
  const [paymentReceiptData, setPaymentReceiptData] = useState({});

  const coupons_data = useQuery("coupons", coupons_api.get, {
    onSuccess: data => setCoupons(data.data),
  });

  const form = useForm({
    initialValues: {
      route: "",
      agents: "",
      start_date: "",
      end_date: "",
      date: new Date(),
    },
    validate: {
      agent: value => (value ? null : "Agent is required"),
      date: value => (value ? null : "Date is required"),
    },
  });

const [packets, setPackets] = useState(0);
const [kgs, setKgs] = useState(0);
const [totalAmount, setTotalAmount] = useState(0);
const [totalItems, setTotalItems] = useState(0);

useEffect(() => {
  let qtySum = 0;
  let amountSum = 0;
  let itemCount = 0;

  invoiceItemsList.forEach(item => {
    if (!item.deleted) {
      qtySum += Number(item.entered_qty) || 0;
      amountSum += Number(item.total) || 0;
      itemCount += 1; // count how many items
    }
  });

  // Split qty into packets & kg
  const whole = Math.floor(qtySum);              // packets
  const decimal = +(qtySum - whole).toFixed(2);  // kg (2 decimal)

  setPackets(whole);
  setKgs(decimal);
  setTotalAmount(Math.round(amountSum)); // round off total amount
  setTotalItems(itemCount);
}, [invoiceItemsList]);




// // Indha function-ah unga InvoiceMaster component-kulla add pannikonga
// const handleItemSelection = (selectedValue) => {
//   // Input box-la value illana, onnum panna vendam
//   if (!selectedValue) return;

//   let productCode = selectedValue;
//   let batchCode = null;

//   // User 'product_code-batch_code' format-la kuduthirukara nu check pannurom
//   if (selectedValue.includes("-")) {
//     const parts = selectedValue.split("-");
//     productCode = parts[0];
//     batchCode = parts[1];
//   }

//   // Kudutha productCode-ah vechu, productsList-la irundhu correct product-ah edukurom
//   const productToAdd = productsList.find((e) => e.code === productCode);

//   // Appadi oru product-ey illana, error kaatitu stop pannidrom
//   if (!productToAdd) {
//     showErrorToast({ title: "Error", message: "Product not found." });
//     return;
//   }

//   let batchToSelect = null;

//   // User oru batch code kuduthirundha, andha specific batch-ah thedrom
//   if (batchCode) {
//     batchToSelect = productToAdd.batches.find(
//       (b) => b.batch_code.toLowerCase() === batchCode.toLowerCase()
//     );

//     // Andha specific batch illana, error kaatidrom
//     if (!batchToSelect) {
//       showErrorToast({
//         title: "Error",
//         message: `Batch '${batchCode}' not found for this product.`,
//       });
//       return;
//     }
//   } else {
//     // User batch code kudukalana, default-ah mudhal batch-ah select pannikalam
//     if (productToAdd.batches && productToAdd.batches.length > 0) {
//       batchToSelect = productToAdd.batches[0];
//     } else {
//       // Product-ku batch-ey illana, error kaatidrom
//       showErrorToast({
//         title: "Error",
//         message: "This product has no available stock/batches.",
//       });
//       return;
//     }
//   }

//   // Indha batch ippove invoice list-la iruka nu check pannurom
//   if (invoiceItemsList.some((item) => item.batch_code === batchToSelect.batch_code)) {
//     showErrorToast({
//       title: "Error",
//       message: "This product with the same batch is already in the invoice.",
//     });
//     return;
//   }

//   // Invoice table-la add panna, oru pudhu item-ah create pannurom
//   const newItem = {
//     ...productToAdd, // product name, tax madhiri details
//     selected_batch: batchToSelect, // select panna batch details
//     batch_code: batchToSelect.batch_code, // batch code mattum
//     qty: 0,
//     entered_qty: 0,
//     total: 0,
//     basic_amount: 0,
//     tax_total: 0,
//     discount: 0,
//     discountPercentage: 0,
//     deleted: false,
//     id: null, // pudhu item-ku 'id' eppovum null ah irukanum
//   };

//   // Create panna item-ah invoice list-la add pannurom
//   addInvoiceItem(newItem);

//   // Pudhusa add panna item-oda 'Qty' input-ku focus kondu poga idhu help pannum
//   setSelectValue(productCode);
//   setFocus(true);
// };
const isDecimalUnit = (unit) => {
    if (!unit) return false;
    const lowerUnit = unit.toLowerCase();
    const decimalUnits = ['kgs', 'gm', 'kg', 'gram', 'ltr', 'ml', 'mtr'];
    return decimalUnits.includes(lowerUnit);
};


const { totalPcs, totalKgs } = React.useMemo(() => {
    let pcs = 0; // Pcs/Nos (Whole Numbers)
    let kgs = 0; // Kgs (Decimal Numbers)

    // *** STEP 2A: invoiceItemsList ஒரு valid Array என்பதை உறுதிப்படுத்தவும் ***
    if (!Array.isArray(invoiceItemsList)) {
        return { totalPcs: 0, totalKgs: 0 };
    }

    invoiceItemsList.forEach(item => {
        // *** STEP 2B: item மற்றும் அதன் key values இருக்கிறதா என சரிபார்க்கவும் ***
        // 'units' ஃபீல்டில் தான் அலகு வருகிறது.
        if (!item || !item.units || !item.qty) {
            return; // இந்த item-ஐத் தவிர்த்து அடுத்த item-க்குச் செல்கிறது
        }
        
        const qty = parseFloat(item.qty) || 0; 
        const unit = item.units; // 'units' என்று சரியாகப் பயன்படுத்தப்பட்டுள்ளது

        // அலகு வகையைப் பொறுத்து மொத்த அளவைச் சேர்த்தல்
        if (isDecimalUnit(unit)) {
            // KGS/GRMS போன்ற தசம அலகுகள்: முழு எண்ணாக இருந்தாலும் KGS-ல் சேரும்.
            kgs += qty;
        } else {
            // PCS/NOS போன்ற முழு எண் அலகுகள்.
            pcs += qty;
        }
    });

    return { totalPcs: pcs, totalKgs: kgs };
}, [invoiceItemsList]);

const updateQty = (batchCode, data, code) => {
  const current_item = invoiceItemsList.find(item => item.code === code);
  console.log("Current modifying item :", current_item);

  let qty_to_fill = 0;

  setInvoiceItemsList(
    produce(draft => {
      const item = draft.find(item => item.code === code);
      const batchIndex = item.batches.findIndex(e => e.batch_code === batchCode);

      const is_qty_overflow = data > item.selected_batch.total_stock;

      if (is_qty_overflow) {
        const usedFromSelected = item.selected_batch.total_stock;
        item.entered_qty = usedFromSelected;
        item.qty = usedFromSelected;
item.basic_amount = item.selected_batch.price * usedFromSelected;
        updateBatch(item.product_code, batchIndex, 0);
        item.selected_batch.stock = 0;

        qty_to_fill = data - usedFromSelected;
        handleBatches(
          current_item.product_code,
          batchCode,
          qty_to_fill,
          batchIndex
        );
      } else {
        item.qty = +data;
        item.entered_qty = +data;
         item.basic_amount = item.selected_batch.price * data;
        updateBatch(item.product_code, batchIndex, item.selected_batch.total_stock - data);
        item.selected_batch.stock = item.selected_batch.total_stock - data;
      }
    })
  );
   setTimeout(updateTotal, 100);
};

// Add these state variables with your other useState declarations
const [editingItem, setEditingItem] = useState(null);
const [editStep, setEditStep] = useState(''); // 'batch', 'qty', 'disc'
const [editProductName, setEditProductName] = useState('');
const [editBatchCode, setEditBatchCode] = useState('');
const [editQty, setEditQty] = useState('');
const [editDiscount, setEditDiscount] = useState('');
const [isEditingMode, setIsEditingMode] = useState(false);

// Edit functionality functions
const handleEditItem = (item) => {
  if (isEditingMode && editingItem?.uniqueId !== item.uniqueId) {
    showErrorToast({
      title: "Editing in Progress",
      message: "Please finish editing the current item first"
    });
    return;
  }

  const uniqueId = `${item.product_code}_${item.batch_code}`;
  setSelectedRow(uniqueId); // Keep row selected when editing
    setEditingItem({
    ...item,
    uniqueId: `${item.product_code}_${item.batch_code}` // Create unique identifier
  });
    setIsEditingMode(true);
    setSelectedProductCode(item.product_code);
  setSelectedProductName(item.product_name);
  setSelectedBatchCode(item.batch_code); // Reset batch code to allow fresh selection
  setTempQty(item.qty || "");
  setTempDiscount(item.discountPercentage || 0);
    // Force show ALL batches for this product (including out of stock)
  // showAllBatchesForProduct(item.product_code);
  // setProductSelectionModal(true);
   // AUTO-LOAD batches in background
  updateModalBatches(item.product_code);
  
  // Auto-focus on quantity
  setTimeout(() => {
    document.getElementById("temp_qty_input")?.focus();
    document.getElementById("temp_qty_input")?.select();
  }, 100);
};
// Handle row click for selection
const handleRowClick = (uniqueId, item) => {
  if (isEditingMode) {
    showErrorToast({
      title: "Editing in Progress",
      message: "Please finish editing the current item first"
    });
    return;
  }
  
  setSelectedRow(uniqueId);
};
const showAllBatchesForProduct = (productCode) => {
  console.log("Showing ALL batches for product:", productCode);
  
  // Find the product in productsList first to get the correct product_code
  const productFromList = productsList.find(
    (product) => product.code === productCode || product.product_code === productCode
  );
  
  if (!productFromList) {
    console.log("Product not found in productsList");
    setModalBatches([]);
    return;
  }

  // Now find the batches for this product from the original batches data
  const productBatch = batches.find(
    (batch) => batch.product_code === productFromList.product_code || batch.product_code === productCode
  );

  console.log("Found product batch with ALL batches:", productBatch);

  if (!productBatch || !productBatch.batches) {
    console.log("No batches found for product");
    setModalBatches([]);
    return;
  }

  // Show ALL batches without filtering out any
  const allBatchesData = productBatch.batches.map(batch => ({
    ...batch,
    product_code: productBatch.product_code
  }));

  console.log("Showing ALL batches:", allBatchesData);
  setModalBatches(allBatchesData);
};

const handleBatchSelectInEdit = (batch) => {
  // ✅ FIRST: Return the existing quantity to the ORIGINAL batch stock
  if (editingItem) {
    setBatches(
      produce(draft => {
        const originalProductBatch = draft.find(p => p.product_code === editingItem.product_code);
        if (originalProductBatch) {
          const originalBatchIndex = originalProductBatch.batches.findIndex(
            b => b.batch_code === editingItem.batch_code
          );
          if (originalBatchIndex !== -1) {
            // Return the existing quantity back to original batch stock
            originalProductBatch.batches[originalBatchIndex].stock += editingItem.qty;
          }
        }
      })
    );
  }

  setSelectedBatchCode(batch.batch_code);
  setProductSelectionModal(false);
  
  setTimeout(() => {
    document.getElementById("temp_qty_input")?.focus();
    document.getElementById("temp_qty_input")?.select();
  }, 150);
};

const handleEditWithOverflow = (productToEdit, selectedBatch, totalQuantity, discountPercent, originalQuantity) => {
  const productCode = productToEdit.product_code;
  
  // Find the product in batches to get all available batches
  const productBatch = batches.find(p => p.product_code === productCode);
  if (!productBatch) return;

  // Find index of selected batch
  const selectedIndex = productBatch.batches.findIndex(b => b.batch_code === selectedBatch.batch_code);
  if (selectedIndex === -1) return;

  let qty_to_fill = totalQuantity;
  const itemsToUpdate = [];

  console.log(`🔄 Starting overflow edit: ${totalQuantity} units needed`);

  setBatches(
    produce(draft => {
      const productBatches = draft.find(p => p.product_code === productCode).batches;
      
      // 1️⃣ First, use as much as possible from selected batch (using TOTAL stock)
      const selectedBatchTotalStock = productBatches[selectedIndex].total_stock;
      const selectedBatchCurrentStock = productBatches[selectedIndex].stock;
      
      // For selected batch, we can use up to its TOTAL stock
      const availableFromSelected = selectedBatchTotalStock;
      const usedFromSelected = Math.min(availableFromSelected, qty_to_fill);
      
      console.log(`📍 Selected batch ${selectedBatch.batch_code}: total_stock=${selectedBatchTotalStock}, using=${usedFromSelected}`);
      
      if (usedFromSelected > 0) {
        // Update stock: current stock minus what we're using
        const newStock = Math.max(0, selectedBatchCurrentStock - usedFromSelected);
        productBatches[selectedIndex].stock = newStock;
        
        qty_to_fill -= usedFromSelected;
        
        const selectedBatchItem = createCompleteInvoiceItem(
          productToEdit,
          {
            ...productBatches[selectedIndex],
            stock: newStock
          },
          usedFromSelected, // Only the allocated portion
          discountPercent
        );
        itemsToUpdate.push(selectedBatchItem);
        console.log(`✅ Added selected batch item: ${usedFromSelected} units`);
      }

            // 2️⃣ CONTINUOUS PASS: Keep using batches BELOW selected batch until no more available
      let passCount = 1;
      while (qty_to_fill > 0) {
        let foundStockInBelowBatches = false;
        
        console.log(`📦 PASS ${passCount} - Need ${qty_to_fill} units from batches BELOW (indices ${selectedIndex + 1} to ${productBatches.length - 1})`);
        
        for (let i = selectedIndex + 1; i < productBatches.length; i++) {
          if (qty_to_fill <= 0) break;
          
          const batch = productBatches[i];
          if (batch.stock > 0) {
            const take = Math.min(batch.stock, qty_to_fill);
            if (take > 0) {
              productBatches[i].stock = Math.max(0, batch.stock - take);
              qty_to_fill -= take;
              foundStockInBelowBatches = true;
              
              const additionalItem = createCompleteInvoiceItem(
                productToEdit,
                batch,
                take,
                discountPercent
              );
              itemsToUpdate.push(additionalItem);
              console.log(`✅ PASS ${passCount} - Added BELOW batch ${batch.batch_code} (index ${i}): ${take} units`);
            }
          }
        }
        
        // If no more stock found in below batches, break the loop
        if (!foundStockInBelowBatches) {
          console.log(`🛑 No more stock available in below batches after ${passCount} passes`);
          break;
        }
        
        passCount++;
      }

      // 3️⃣ FINAL PASS: If STILL needed, start from FIRST batch in the list and go sequentially

      if (qty_to_fill > 0) {
        console.log(`📦 Still need ${qty_to_fill} units from other batches`);
        
        for (let i = 0; i < productBatches.length; i++) {
          // if (i === selectedIndex) continue; // Skip selected batch (already used)
          if (qty_to_fill <= 0) break;

          // Skip batches that were already used in previous steps
          const batchAlreadyUsed = itemsToUpdate.some(item => item.batch_code === productBatches[i].batch_code);
          if (batchAlreadyUsed) continue;
          
          const batch = productBatches[i];
          if (batch.stock > 0) {
            const take = Math.min(batch.stock, qty_to_fill);
            if (take > 0) {
              productBatches[i].stock = Math.max(0, batch.stock - take);
              qty_to_fill -= take;
              
              const additionalItem = createCompleteInvoiceItem(
                productToEdit,
                batch,
                take, // Only take what's needed
                discountPercent
              );
              itemsToUpdate.push(additionalItem);
              console.log(`✅ Added additional batch ${batch.batch_code}: ${take} units`);
            }
          }
        }
      }
    })
  );

  // ✅ CRITICAL FIX: Wait for batches to update, then update invoice items
  setTimeout(() => {
    setInvoiceItemsList(
      produce(draft => {
        // Remove the original editing item
        const originalIndex = draft.findIndex(item => 
          item.batch_code === editingItem.batch_code&& 
          item.product_code === editingItem.product_code
        );
        if (originalIndex !== -1) {
          draft.splice(originalIndex, 1);
          console.log(`🗑️ Removed original item with batch ${editingItem.batch_code}`);
        }
        
        // Add ALL the overflow items as SEPARATE rows
        itemsToUpdate.forEach((item, index) => {
          // Create unique identifier for each split item
          const uniqueItem = {
            ...item,
            // Create unique code for each split item to avoid conflicts
            code: `${item.code}_${item.batch_code}_${Date.now()}_${index}`,
            id: null // Ensure new items have null ID
          };
          draft.unshift(uniqueItem);
          console.log(`➕ Added separate row: ${uniqueItem.batch_code} - ${uniqueItem.qty} units`);
        });
      })
    );

    // Verify the total
    const totalAdded = itemsToUpdate.reduce((sum, item) => sum + item.qty, 0);
    console.log(`🎯 Total added across batches: ${totalAdded}, Requested: ${totalQuantity}`);

    if (totalAdded !== totalQuantity) {
      console.error(`❌ Quantity mismatch: Added ${totalAdded} but requested ${totalQuantity}`);
    }

    updateTotal();

    // Show success message with batch breakdown
    if (itemsToUpdate.length > 1) {
      showSuccessToast({
        title: "Stock Distributed",
        message: `Quantity distributed across ${itemsToUpdate.length} batches`
        // message: `Quantity distributed across ${itemsToUpdate.length} batches: ${itemsToUpdate.map(item => `${item.batch_code} (${item.qty})`).join(', ')}`
      });
    }

    // Reset edit state
    setEditingItem(null);
    setIsEditingMode(false);
    handleClearSelection();
  }, 100);
};
// ✅ UPDATED: Handle single batch editing (no overflow)
const handleSingleBatchEdit = (productToEdit, batchToEdit, quantity, discountPercent, originalQuantity) => {
  // Check if this would create a duplicate (if changing to existing batch)
  if (selectedBatchCode && selectedBatchCode !== editingItem.batch_code) {
    const existingItem = invoiceItemsList.find(
      item => item.product_code === productToEdit.product_code && 
      item.batch_code === selectedBatchCode &&
      item.batch_code !== editingItem.batch_code // Exclude the current editing item
    );

    if (existingItem) {
      showErrorToast({
        title: "Error",
        message: "This product and batch combination is already in the invoice!",
      });
      return;
    }
  }

  // Update batches state
  setBatches(
    produce(draft => {
      const productBatch = draft.find(p => p.product_code === productToEdit.product_code);
      if (productBatch) {
        // If changing batches, return original quantity to original batch
        if (selectedBatchCode && selectedBatchCode !== editingItem.batch_code) {
          const originalBatchIndex = productBatch.batches.findIndex(
            b => b.batch_code === editingItem.batch_code
          );
          if (originalBatchIndex !== -1) {
            productBatch.batches[originalBatchIndex].stock += originalQuantity;
          }
        }
        
        // Deduct new quantity from target batch
        const targetBatchIndex = productBatch.batches.findIndex(b => b.batch_code === batchToEdit.batch_code);
        if (targetBatchIndex !== -1) {
          const newStock = Math.max(0, productBatch.batches[targetBatchIndex].stock - quantity);
          productBatch.batches[targetBatchIndex].stock = newStock;
        }
      }
    })
  );

  // Update the invoice item
  setInvoiceItemsList(
    produce(draft => {
      const item = draft.find(i => i.product_code === editingItem.product_code &&
    i.batch_code === editingItem.batch_code);
      
      if (item) {
        // If batch was changed, update batch details
        if (selectedBatchCode && selectedBatchCode !== editingItem.batch_code) {
          const newBatch = productToEdit.batches.find(b => b.batch_code === selectedBatchCode);
          if (newBatch) {
            item.selected_batch = {
              ...newBatch,
              stock: newBatch.stock - quantity
            };
            item.batch_code = newBatch.batch_code;
            item.expiry_date = newBatch.expiry_date;
          }
        }

        // Update quantity and recalculate amounts
        item.qty = quantity;
        item.entered_qty = quantity;
        item.basic_amount = item.selected_batch.price * quantity;
        item.discountPercentage = discountPercent;
        item.discount = (item.basic_amount * discountPercent) / 100;
        
        const reduced_rate = item.basic_amount - item.discount;
        const taxPercentage = item.tax || 0;
        const denominator = 100 + taxPercentage;
        const tax = (reduced_rate - (reduced_rate / denominator) * 100).toFixed(2);
        
        item.tax_total = Number(tax);
        item.total = reduced_rate;
      }
    })
  );
};
const handleEditEnter = () => {
  if (!editingItem || !editingItem.qty) {
    showErrorToast({ 
      title: "Error", 
      message: "Please enter valid quantity!" 
    });
    return;
  }

  const quantity = parseFloat(editingItem.qty) || 0;
  const discountPercent = parseFloat(editingItem.discountPercentage) || 0;

  if (quantity <= 0) {
    showErrorToast({ 
      title: "Error", 
      message: "Please enter a valid quantity!" 
    });
    return;
  }

  // Find the product and batch details
  const productToEdit = productsList.find(p => p.product_code === editingItem.product_code);
  const targetBatchCode = selectedBatchCode || editingItem.batch_code;
  const batchToEdit = productToEdit?.batches.find(b => b.batch_code === targetBatchCode);

  if (!productToEdit || !batchToEdit) {
    showErrorToast({ 
      title: "Error", 
      message: "Product or batch not found!" 
    });
    return;
  }

  // ✅ CALCULATE TOTAL AVAILABLE STOCK CORRECTLY FOR EDITING
const productBatch = batches.find(p => p.product_code === editingItem.product_code);
let totalAvailableStock = 0;

if (productBatch?.batches) {
  const targetBatchCode = selectedBatchCode || editingItem.batch_code;
  
  // Find the selected batch first
  const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
  if (selectedBatch) {
    // Add selected batch's TOTAL stock
    totalAvailableStock += selectedBatch.total_stock || 0;
  }
  
  // Add other batches' CURRENT stock
  productBatch.batches.forEach(batch => {
    if (batch.batch_code !== targetBatchCode) {
      totalAvailableStock += batch.stock || 0;
    }
  });
}
totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));
console.log(`Edit - Total available: ${totalAvailableStock} (Selected batch total + Other batches current)`);

// ✅ Check if total quantity exceeds available stock
if (quantity > totalAvailableStock) {
  showErrorToast({
    title: "Insufficient Stock",
    message: `Only ${totalAvailableStock} units available `
  });
  return;
}

  // ✅ OVERFLOW LOGIC FOR EDITING MODE - Check against selected batch's TOTAL stock
  const is_qty_overflow = quantity > batchToEdit.total_stock;

  if (is_qty_overflow) {
    // Use overflow logic - distribute quantity across multiple batches
    handleEditWithOverflow(
      productToEdit,
      batchToEdit,
      quantity,
      discountPercent,
      editingItem.qty || 0
    );
    return;
  } else {
    // Normal case - selected batch has sufficient TOTAL stock
    handleSingleBatchEdit(
      productToEdit,
      batchToEdit,
      quantity,
      discountPercent,
      editingItem.qty || 0
    );
  }
// Update the invoice list with edited values
  setInvoiceItemsList(
    produce(draft => {
      const item = draft.find(i =>i.product_code === editingItem.product_code &&
    i.batch_code === editingItem.batch_code);
      if (item) {
        item.qty = quantity;
        item.entered_qty = quantity;
        item.discountPercentage = discountPercent;
        
        // Recalculate amounts
        item.basic_amount = item.selected_batch.price * quantity;
        item.discount = (item.basic_amount * discountPercent) / 100;
        
        const reduced_rate = item.basic_amount - item.discount;
        const taxPercentage = item.tax || 0;
        const denominator = 100 + taxPercentage;
        const tax = (reduced_rate - (reduced_rate / denominator) * 100).toFixed(2);
        
        item.tax_total = Number(tax);
        item.total = reduced_rate;
      }
    })
  );
  // Update totals
  updateTotal();

  // Show success message
  showSuccessToast({
    title: "Success",
    message: "Product edited successfully!"
  });

  // Reset edit state
  setSelectedRow(null);
  setIsListFocused(false);
  setEditingItem(null);
  setIsEditingMode(false);
  handleClearSelection();

  // Refocus to search bar for new product
  setTimeout(() => {
    const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
    if (searchInput) {
      searchInput.focus();
      searchInput.select();
    }
  }, 100);
};

const cancelEdit = () => {
  if (editingItem) {
    // Show confirmation message
    showSuccessToast({
      title: "Edit Cancelled",
      message: "Changes discarded and original product restored"
    });
  }
  
  // Reset edit state and clear fields
  setEditingItem(null);
  setIsEditingMode(false);
  setSelectedRow(null);
  setIsListFocused(false);
  setEditStep('');
  setEditProductName('');
  setEditBatchCode('');
  setEditQty('');
  setEditDiscount('');
  
  // Clear the product search fields
  handleClearSelection();
  
  // Refocus to search bar for new product
  setTimeout(() => {
    const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
    if (searchInput) {
      searchInput.focus();
      searchInput.select();
    }
  }, 100);
};

// Add keyboard navigation for edit flow
useEffect(() => {
  const handleEditKeyDown = (event) => {
    if (!editingItem) return;

    if (event.key === 'Escape') {
      cancelEdit();
    } else if (event.key === 'Enter') {
      if (editStep === 'batch') {
        // Auto-select first available batch if in batch selection
        if (modalBatches.length > 0 && !editBatchCode) {
          handleBatchSelectInEdit(modalBatches[0]);
        }
      } else if (editStep === 'qty') {
        setEditStep('disc');
        setTimeout(() => {
          const discountInput = document.getElementById(`edit_discount_${editingItem.batch_code}`);
          if (discountInput) {
            discountInput.focus();
            discountInput.select();
          }
        }, 150);
      } else if (editStep === 'disc') {
        handleEditEnter();
      }
    }
  };

  window.addEventListener('keydown', handleEditKeyDown);
  return () => window.removeEventListener('keydown', handleEditKeyDown);
}, [editingItem, editStep, editBatchCode, modalBatches]);

// Add these state variables with your other useState declarations
const [selectedProductCode, setSelectedProductCode] = useState(null);
const [selectedProductName, setSelectedProductName] = useState("");
const [selectedBatchCode, setSelectedBatchCode] = useState(null);
const [selectedBatchName, setSelectedBatchName] = useState("");
const [tempQty, setTempQty] = useState("");
const [tempDiscount, setTempDiscount] = useState("");

// Clear function to reset only the current product selection
const handleClearSelection = () => {
  setTempQty("");
  setTempDiscount("");
  setSearchValue("");
  setSelectedProductCode(null);
  setSelectedProductName("");
  setSelectedBatchCode(null);
  setSelectedBatchName("");
  setCurrentBatch({});
  
  // Refocus to product search immediately
  setTimeout(() => {
    const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
    if (searchInput) {
      searchInput.focus();
      searchInput.select();
    }
  }, 50);
};
// Add this reset function:
const resetAddProductFields = () => {
  setTempQty("");
  setTempDiscount("");
  setSearchValue("");
  setSelectedBatchCode(null);
  setSelectedProductName(""); 
  setSelectedBatchName("");
  // Refocus to product search
  setTimeout(() => {
    const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
    if (searchInput) searchInput.focus();
  }, 100);
};

// Update the batch selection handler:
const handleBatchSelect = newBatch => {
  if (newBatch?.product_code) {
    resetBatchQty(newBatch?.product_code);
  }

  // ✅ CHECK IF PRODUCT+BATCH ALREADY EXISTS IN INVOICE
  const existingItem = invoiceItemsList.find(
    item => item.product_code === newBatch.product_code && 
    item.batch_code === newBatch.batch_code
  );
  
  if (existingItem) {
    // ✅ AUTOMATICALLY SWITCH TO EDITING MODE FOR THIS ITEM
    handleEditItem(existingItem);
    
    // Show informative message
    showSuccessToast({
      title: "Editing Mode Activated",
      message: `You're now editing ${existingItem.product_name} (${existingItem.batch_code})`
    });
    
    setProductSelectionModal(false);
    return; // Stop further execution
  }

  setSelectedBatchCode(newBatch.batch_code);
  setSelectedBatchName(newBatch.batch_code);
 
  setProductSelectionModal(false);
  
  // Auto-focus to quantity input only if product is not already in invoice
  setTimeout(() => {
    document.getElementById("temp_qty_input")?.focus();
  }, 150);
};

const handleProductWithOverflow = (productToAdd, selectedBatch, totalQuantity, discountPercent) => {
  const productCode = productToAdd.product_code;
  const batchCode = selectedBatch.batch_code;
  
  // Find the product in batches to get all available batches
  const productBatch = batches.find(p => p.product_code === productCode);
  if (!productBatch) return;

  // Find index of selected batch
  const selectedIndex = productBatch.batches.findIndex(b => b.batch_code === batchCode);
  if (selectedIndex === -1) return;

  let qty_to_fill = totalQuantity;
  const itemsToAdd = [];

  setBatches(
    produce(draft => {
      const productBatches = draft.find(p => p.product_code === productCode).batches;
      
      // 1️⃣ First, use as much as possible from selected batch (up to TOTAL stock)
      const selectedBatchTotalStock = productBatches[selectedIndex].total_stock;
      const selectedBatchCurrentStock = productBatches[selectedIndex].stock;
      
      // For selected batch, we can use up to its TOTAL stock (not just current stock)
      const availableFromSelected = selectedBatchTotalStock;
      const usedFromSelected = Math.min(availableFromSelected, qty_to_fill);
      
      if (usedFromSelected > 0) {
        // Update stock: current stock minus what we're using
        const newStock = Math.max(0, selectedBatchCurrentStock - usedFromSelected);
        productBatches[selectedIndex].stock = newStock;
        
        qty_to_fill -= usedFromSelected;
        
        const selectedBatchItem = createCompleteInvoiceItem(
          productToAdd,
          {
            ...productBatches[selectedIndex],
            stock: newStock
          },
          usedFromSelected,
          discountPercent
        );
        itemsToAdd.push(selectedBatchItem);
      }

       // 2️⃣ CONTINUOUS PASS: Keep using batches BELOW selected batch until no more available
      let passCount = 1;
      while (qty_to_fill > 0) {
        let foundStockInBelowBatches = false;
        
        console.log(`📦 PASS ${passCount} - Need ${qty_to_fill} units from batches BELOW (indices ${selectedIndex + 1} to ${productBatches.length - 1})`);
        
        for (let i = selectedIndex + 1; i < productBatches.length; i++) {
          if (qty_to_fill <= 0) break;
          
          const batch = productBatches[i];
          // For other batches, only use current stock (not total_stock)
          if (batch.stock > 0) {
            const take = Math.min(batch.stock, qty_to_fill);
            if (take > 0) {
              productBatches[i].stock = Math.max(0, batch.stock - take);
              qty_to_fill -= take;
              foundStockInBelowBatches = true;
              
              const additionalItem = createCompleteInvoiceItem(
                productToAdd,
                batch,
                take,
                discountPercent
              );
              itemsToAdd.push(additionalItem);
              console.log(`✅ PASS ${passCount} - Added BELOW batch ${batch.batch_code} (index ${i}): ${take} units`);
            }
          }
        }
        
        // If no more stock found in below batches, break the loop
        if (!foundStockInBelowBatches) {
          console.log(`🛑 No more stock available in below batches after ${passCount} passes`);
          break;
        }
        
        passCount++;
      }

      // 3️⃣ FINAL PASS: If STILL needed, start from FIRST batch in the list and go sequentially
      if (qty_to_fill > 0) {
        console.log(`📦 FINAL PASS - Still need ${qty_to_fill} units, starting from FIRST batch in list`);
        
        for (let i = 0; i < productBatches.length; i++) {
          if (qty_to_fill <= 0) break;
          
          // Skip batches that were already used in previous steps
          const batchAlreadyUsed = itemsToAdd.some(item => item.batch_code === productBatches[i].batch_code);
          if (batchAlreadyUsed) continue;
          
          const batch = productBatches[i];
          // For other batches, only use current stock (not total_stock)
          if (batch.stock > 0) {
            const take = Math.min(batch.stock, qty_to_fill);
            if (take > 0) {
              productBatches[i].stock = Math.max(0, batch.stock - take);
              qty_to_fill -= take;
              
              const additionalItem = createCompleteInvoiceItem(
                productToAdd,
                batch,
                take,
                discountPercent
              );
              itemsToAdd.push(additionalItem);
            }
          }
        }
      }
    })
  );

  // Add all items to invoice
  itemsToAdd.forEach(item => {
    addInvoiceItem(item);
  });

  updateTotal();

  // Show success message with batch breakdown
  if (itemsToAdd.length > 1) {
    showSuccessToast({
      title: "Stock Distributed",
      message: `Quantity distributed across ${itemsToAdd.length} batches`
    });
  }
};
// ✅ NEW: Helper function to create complete invoice items
const createCompleteInvoiceItem = (product, batch, quantity, discountPercent) => {
  const basic_amount = batch.price * quantity;
  const discount_amount = (basic_amount * discountPercent) / 100;
  const total_amount = basic_amount - discount_amount;

  console.log(`🆕 Creating complete invoice item: ${product.product_name}, Batch: ${batch.batch_code}, Qty: ${quantity}`);

  return {
    ...product,
    // Create unique identifier for this split item
    code: `${product.code}_${batch.batch_code}_split`, // Temporary, will be made unique later
    product_name: product.product_name || product.label,
    selected_unit: product.units,
    precision: isDecimalUnit(product.units) ? 3 : 0,
    allowDecimal: isDecimalUnit(product.units),
    selected_batch: {
      ...batch,
      stock: batch.stock - quantity,
    },
    batch_code: batch.batch_code,
    qty: quantity,
    entered_qty: quantity,
    basic_amount: basic_amount,
    discountPercentage: discountPercent,
    discount: discount_amount,
    tax_total: 0,
    total: total_amount,
    deleted: false,
    id: null, // IMPORTANT: New items must have null ID
  };
};
// Handle single batch product (no overflow)
const handleSingleBatchProduct = (productToAdd, batchToAdd, quantity, discountPercent) => {
  // Check if this product+batch already exists in invoice
  const existingItem = invoiceItemsList.find(
    item => item.product_code === productToAdd.product_code && 
    item.batch_code === batchToAdd.batch_code
  );

  if (existingItem) {
    showErrorToast({
      title: "Error",
      message: "This product and batch combination is already in the invoice!",
    });
    return;
  }
// ✅ ADD STOCK VALIDATION
  if (quantity > batchToAdd.stock) {
    showErrorToast({
      title: "Insufficient Stock",
      message: `Only ${batchToAdd.stock} units available in batch ${batchToAdd.batch_code}`
    });
    setTimeout(() => {
      document.getElementById("temp_qty_input")?.focus();
      document.getElementById("temp_qty_input")?.select();
    }, 100);
    return;
  }
  // Update batches state
  setBatches(
    produce(draft => {
      const productBatch = draft.find(p => p.product_code === productToAdd.product_code);
      if (productBatch) {
        const batchIndex = productBatch.batches.findIndex(b => b.batch_code === batchToAdd.batch_code);
        if (batchIndex !== -1) {
          // ✅ SAFE DEDUCTION: Ensure we don't go negative
          const newStock = Math.max(0, productBatch.batches[batchIndex].stock - quantity);
          productBatch.batches[batchIndex].stock = newStock;
        }
      }
    })
  );

  // Create and add invoice item
  const newItem = createInvoiceItem(
    productToAdd,
    batchToAdd,
    quantity,
    discountPercent
  );

  addInvoiceItem(newItem);
  updateTotal();
};

// Helper function to create invoice items
const createInvoiceItem = (product, batch, quantity, discountPercent) => {
  const basic_amount = batch.price * quantity;
  const discount_amount = (basic_amount * discountPercent) / 100;
  const total_amount = basic_amount - discount_amount;

  return {
    ...product,
    selected_unit: product.units,
    precision: isDecimalUnit(product.units) ? 3 : 0,
    allowDecimal: isDecimalUnit(product.units),
    selected_batch: {
      ...batch,
      stock: batch.stock - quantity, // Updated stock
    },
    batch_code: batch.batch_code,
    qty: quantity,
    entered_qty: quantity,
    basic_amount: basic_amount,
    discountPercentage: discountPercent,
    discount: discount_amount,
    tax_total: 0,
    total: total_amount,
    deleted: false,
    id: null,
  };
};

const handleAddProductEntry = () => {
  if (!selectedProductCode || !selectedBatchCode || !tempQty) {
    showErrorToast({ 
      title: "Error", 
      message: "Please select product, batch and enter quantity!" 
    });
    return;
  }

  const quantity = parseFloat(tempQty) || 0;
  const discountPercent = parseFloat(tempDiscount) || 0;

  if (quantity <= 0) {
    showErrorToast({ 
      title: "Error", 
      message: "Please enter a valid quantity!" 
    });
    return;
  }

  // Find product and batch
  const productToAdd = productsList.find(p => p.code === selectedProductCode);
  const batchToAdd = productToAdd?.batches.find(b => b.batch_code === selectedBatchCode);

  if (!productToAdd || !batchToAdd) {
    showErrorToast({ 
      title: "Error", 
      message: "Product or batch not found!" 
    });
    return;
  }

  // ✅ CALCULATE TOTAL AVAILABLE STOCK CORRECTLY
  const productBatch = batches.find(p => p.product_code === productToAdd.product_code);
  let totalAvailableStock = 0;
  
  if (productBatch?.batches) {
    // Selected batch: can use up to total_stock
    const selectedBatch = productBatch.batches.find(b => b.batch_code === selectedBatchCode);
    if (selectedBatch) {
      totalAvailableStock += selectedBatch.total_stock || 0;
    }
    
    // Other batches: can only use current stock
    productBatch.batches.forEach(batch => {
      if (batch.batch_code !== selectedBatchCode) {
        totalAvailableStock += batch.stock || 0;
      }
    });
  }
totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));
  console.log(`Total available: ${totalAvailableStock} (Selected batch total + Other batches current stock)`);

  // ✅ Check if total quantity exceeds TOTAL available stock
  if (quantity > totalAvailableStock) {
    showErrorToast({
      title: "Insufficient Stock",
      message: `Only ${totalAvailableStock} units available `
    });
    return;
  }

  // Check if this product+batch already exists in invoice
  const existingItem = invoiceItemsList.find(
    item => item.product_code === productToAdd.product_code && 
    item.batch_code === selectedBatchCode
  );

  if (existingItem) {
    showErrorToast({
      title: "Error",
      message: "This product and batch combination is already in the invoice!",
    });
    return;
  }

  // ✅ Check if we need overflow logic
  const selectedBatchCurrentStock = batchToAdd.stock;
  const is_qty_overflow = quantity > selectedBatchCurrentStock;

  if (is_qty_overflow) {
    // Use overflow logic - distribute quantity across multiple batches
    console.log(`Overflow needed: ${quantity} > ${selectedBatchCurrentStock} (selected batch current stock)`);
    handleProductWithOverflow(
      productToAdd, 
      batchToAdd, 
      quantity, 
      discountPercent
    );
  } else {
    // Normal case - selected batch has sufficient CURRENT stock
    console.log(`Single batch sufficient: ${quantity} <= ${selectedBatchCurrentStock}`);
    handleSingleBatchProduct(
      productToAdd, 
      batchToAdd, 
      quantity, 
      discountPercent
    );
  }

  // Reset fields
  resetAddProductFields();
};



  // const resetBatchQty = (product_code) => {
  //   const selectedProduct = batches.find(e => e.product_code === product_code);
  //   if (selectedProduct) {
  //     const resetValue=selectedProduct.batches.map(batch => ({
  //         ...batch,
  //         stock:batch?.total_stock,
  //         product_code: selectedProduct.product_code
  //       }))

  //      setModalBatches(resetValue)
  //      setBatches(batches.map((batch)=>{
  //       if(batch?.product_code === product_code){
  //         return{
  //           ...batch,
  //           batches:resetValue,
  //         }
  //       }
  //       return batch
  //      }))
  //   }
  // }

  // const updateModalBatches = product_code => {
  //   setModalBatches(batches.find(e => e.product_code === product_code).batches);
  // };

  // const resetBatchQty = (product_code) => {
  //   if (!batches || !Array.isArray(batches) || batches.length === 0) return;

  //   const updatedBatches = batches.map(product => {
  //     if (product?.product_code === product_code && Array.isArray(product.batches)) {
  //       const resetBatches = product.batches.map(batch => ({
  //         ...batch,
  //         stock: batch?.total_stock,
  //         product_code
  //       }));

  //       if (product_code === product_code) {
  //         setModalBatches(resetBatches); // Update modal batches only once
  //       }
  //       console.log('qqq-227',resetBatches)
  //       return { ...product, batches: resetBatches };
  //     }
  //     return product;
  //   });

  //   setBatches(updatedBatches);
  // };
// Arrow key navigation between rows
const handleArrowKeyNavigation = (key) => {
  if (!invoiceItemsList.length) return;
  
  const currentIndex = invoiceItemsList.findIndex(item => 
    `${item.product_code}_${item.batch_code}` === selectedRow
  );
  
  let newIndex;
  if (key === 'ArrowDown') {
    newIndex = currentIndex === -1 ? 0 : Math.min(currentIndex + 1, invoiceItemsList.length - 1);
  } else if (key === 'ArrowUp') {
    newIndex = currentIndex === -1 ? 0 : Math.max(currentIndex - 1, 0);
  }
  
  if (newIndex >= 0 && newIndex < invoiceItemsList.length) {
    const newItem = invoiceItemsList[newIndex];
    const newUniqueId = `${newItem.product_code}_${newItem.batch_code}`;
    setSelectedRow(newUniqueId);
  }
};


  const resetBatchQty = (product_code) => {

    const batch_code = currentBatch?.batch_code

    if (!batches || !Array.isArray(batches) || batches.length === 0) return;

    const updatedBatches = batches.map(product => {
      if (product?.product_code === product_code && Array.isArray(product.batches)) {
        const resetBatches = product.batches.map(batch =>
          batch.batch_code === batch_code
            ? { ...batch, stock: batch.total_stock }  // Reset stock only for the selected batch
            : batch
        );

        return { ...product, batches: resetBatches };
      }
      return product;
    });

    const selectedProduct = updatedBatches.find(p => p.product_code === product_code);
    if (selectedProduct) {
      const selectedBatch = selectedProduct.batches.find(b => b.batch_code === batch_code);
      if (selectedBatch) {
        setModalBatches([selectedBatch]);
      }
    }

    setBatches(updatedBatches);
  };


  const updateModalBatches = (product_Code) => {
  console.log("Updating modal batches for product:", product_Code);
  // If we're in editing mode, show ALL batches
  if (isEditingMode) {
    showAllBatchesForProduct(product_Code);
    return;
  }
  // For normal mode, use your existing logic
  const productFromList = productsList.find(
    (product) => product.code === product_Code || product.product_code === product_Code
  );
  
  if (!productFromList) {
    console.log("Product not found in productsList");
    setModalBatches([]);
    return;
  }

  // Now find the batches for this product
  const productBatch = batches.find(
    (batch) => batch.product_code === productFromList.product_code || batch.product_code === product_Code
  );

  console.log("Found product batch:", productBatch);

  if (!productBatch || !productBatch.batches) {
    console.log("No batches found for product");
    setModalBatches([]);
    return;
  }

  // Map batches with proper product_code
  const modalBatchesData = productBatch.batches.map(batch => ({
    ...batch,
    product_code: productBatch.product_code
  }));

  console.log("Modal batches to show:", modalBatchesData);
  setModalBatches(modalBatchesData);
};


  const updateBatchInList = newBatch => {
  if (newBatch?.product_code) {
    resetBatchQty(newBatch?.product_code);
  }

  setInvoiceItemsList(
    produce(draft => {
      // Find the current product row in the invoice items
      const selectedInvoiceItem = draft.find(
        e => e.product_code === newBatch.product_code
      );

      if (!selectedInvoiceItem) {
        console.warn("⚠️ Skipped batch update — product not found:", newBatch);
        return;
      }

      // Always allow switching to any batch inside the same product
      selectedInvoiceItem.selected_batch = newBatch;
      selectedInvoiceItem.batch_code = newBatch.batch_code;
      selectedInvoiceItem.expiry_date = newBatch.expiry_date;
      // selectedInvoiceItem.price = newBatch.price;
      selectedInvoiceItem.qty = 0;
      selectedInvoiceItem.total = 0;
      selectedInvoiceItem.total_tax = 0;
      selectedInvoiceItem.box = 0;
      selectedInvoiceItem.pieces = 0;
      selectedInvoiceItem.entered_qty = 0;

      updateTotal();
    })
  );
};


const checkIfBatchAlreadyExists = (product_code, batch_code) => {
  return invoiceItemsList.some(
    e => e.product_code === product_code && e.batch_code === batch_code
  );
};


  const updateBatch = useCallback((product_code, index, data) => {
    console.log({
      batches,
    });
    setBatches(
      produce(draft => {
        let batch = draft.find(i => i.product_code === product_code);
        console.log("bbb", index, batch.batches, draft, batch);
        batch.batches[index].stock = data;
      })
    );
  }, []);

  const updateTotal = useCallback((itemId, data) => {
  setInvoiceItemsList(
    produce(draft => {
      for (let item of draft) {
        const price = Number(item?.selected_batch?.price) || 0;
        const qty = Number(item.qty) || 0;
        const discountAmount = Number(item.discount) || 0;
        const taxPercentage = Number(item.tax) || 0;
        
        // Calculate basic amount (price × quantity)
        item.basic_amount = price * qty;
        
        // Calculate amount after discount
        const amountAfterDiscount = item.basic_amount - discountAmount;
        
        // Calculate tax (if needed)
        const denominator = 100 + taxPercentage;
        const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);
        
        item.tax_total = Number(tax);
        item.total = amountAfterDiscount;

        console.log("💰 Amount Calculation:", {
          product: item.product_name,
          price: price,
          qty: qty,
          basic_amount: item.basic_amount,
          discount: discountAmount,
          total: item.total
        });
      }
    })
  );
}, []);

  const resetInvoiceItem = useCallback(itemId => {
    setInvoiceItemsList(draft => {
      const item = draft.find(item => item.id === itemId);
      item.entered_qty = 0;
      item.qty = 0;
      item.total = 0;
      item.tax_total = 0;
    });
  }, []);

  const updateInvoiceItem = useCallback((type, itemId, data) => {
    // Function for updating static values in invoice items which doesn't require any calculations
    setInvoiceItemsList(draft => {
      const item = draft.find(item => item.id === itemId);
      console.log(item);
      switch (type) {
        case "discount":
          item.discount = data;
          break;
        case "free_samples":
          item.free_samples = data;
          break;
        default:
          break;
      }
    });
  }, []);

  const getTotal = (type, inVoiceItems, appliedCoupon, packageCharge) => {
    let getAppliedcoupon = appliedCoupon ? appliedCoupon : couponApplied;
    let getPackingCharge = Number(packageCharge ? packageCharge : packingCharge);

    let total_amount = 0;
    let tax_total = 0;
    let boxes = 0;
    let pieces = 0;
    let free_samples = 0;
    let discount = 0;
    let subtotal = 0;
    let coupon = 0;
    let packing_charge = packingCharge;

    for (let item of (inVoiceItems ? inVoiceItems : invoiceItemsList)) {
      total_amount += item.total;
      tax_total += item.tax_total;
      boxes += item.box;
      pieces += item.pieces;
      free_samples += item.free_samples;
      discount += item.discount;
      subtotal += item.basic_amount;
    }
    if (getAppliedcoupon !== undefined)
      coupon =
        getAppliedcoupon.coupon_type === "Flat"
          ? Number(total_amount * (getAppliedcoupon.value / 100)).toFixed(2)
          : Number(getAppliedcoupon.value).toFixed(2);
    coupon = isNaN(coupon) ? 0 : coupon;
    total_amount -= coupon;
    total_amount = total_amount + getPackingCharge;

    switch (type) {
      case "packing_charge":
        return packing_charge;
      case "amount":
        return total_amount;
      case "subtotal":
        return subtotal - tax_total;
      case "discount":
        return discount;
      case "coupon":
        return coupon;
      case "tax":
        return tax_total;
      case "boxes":
        return boxes;
      case "pieces":
        return pieces;
      case "free_samples":
        return free_samples;
      default:
        break;
    }
  };

  const updateInvoiceItemData = (batchCode, qty, stock) => {
    setInvoiceItemsList(
      produce(draft => {
        let product = draft.find(e => e.batch_code === batchCode);
        console.log("Product changing");
        product.entered_qty += +qty;
        product.qty += +qty;
        product.selected_batch.stock = +stock;
      })
    );
  };

  const updateDiscount = (productCode,batchCode, discountPercentage) => {
    console.log({
      productCode,
      batchCode,
      discountPercentage,
    });
    setInvoiceItemsList(
      produce(draft => {
        let product = draft.find(e => e.product_code === productCode && e.batch_code === batchCode);
        product.discountPercentage = +discountPercentage;

        const discount = product.basic_amount * (+discountPercentage / 100);
        product.discount = +discount.toFixed(2);

        console.log(discount);

        // product.selected_batch.stock = +stock;
      })
    );
  };

  const applyNetDiscount = () => {
    for (let item of invoiceItemsList) {
      updateDiscount(item.product_code,item.batch_code, netDiscount);
    }
    updateTotal();
  };

  const applyCoupon = set => {
    console.log(couponCode.coupon_code);
    if (set) {
      let coupon = coupons.find(value => value.coupon_code === couponCode.coupon_code);
      console.log(coupon);
      setCouponApplied(coupon);
    } else {
      setCouponApplied({});
    }
    console.log(couponApplied);
  };

const handleBatches = (productCode, batchCode, total_stock_needed, selectedIndex) => {
  setBatches(
    produce(draft => {
      const product = invoiceItemsList.find(e => e.product_code === productCode);
      const batches = draft.find(e => e.product_code === productCode).batches;

      let fulfilled_stock = 0;
      const selected_batches = [];

      const is_batch_already_present = code =>
        invoiceItemsList.some(e => e.batch_code === code);

      // 1️⃣ consume DOWNWARDS (after selectedIndex)
      for (let i = selectedIndex + 1; i < batches.length; i++) {
        if (fulfilled_stock >= total_stock_needed) break;

        let batch = batches[i];
        let needed = total_stock_needed - fulfilled_stock;
        if (batch.stock <= 0) continue;

        let take = Math.min(batch.stock, needed);
        fulfilled_stock += take;
        batch.stock -= take;

        if (is_batch_already_present(batch.batch_code)) {
          updateInvoiceItemData(batch.batch_code, take, batch.stock);
        } else {
          selected_batches.push({
            ...product,
            product_name: product.product_name, // Ensure product name is included
            product_code: product.product_code,
            code: product.code,
            tax: product.tax,
            units: product.units,
            selected_unit: product.units,
            precision: isDecimalUnit(product.units) ? 3 : 0,
            allowDecimal: isDecimalUnit(product.units),
            deleted: false,
            id: null,
            batch_code: batch.batch_code,
            selected_batch: { ...batch },
            qty: take,
            entered_qty: take,
          });
        }
      }

      // 2️⃣ if still needed, consume UPWARDS (before selectedIndex)
      if (fulfilled_stock < total_stock_needed) {
        for (let i = selectedIndex - 1; i >= 0; i--) {
          if (fulfilled_stock >= total_stock_needed) break;

          let batch = batches[i];
          let needed = total_stock_needed - fulfilled_stock;
          if (batch.stock <= 0) continue;

          let take = Math.min(batch.stock, needed);
          fulfilled_stock += take;
          batch.stock -= take;

          if (is_batch_already_present(batch.batch_code)) {
            updateInvoiceItemData(batch.batch_code, take, batch.stock);
          } else {
            selected_batches.push({
              ...product,
              deleted: false,
              id: null,
              batch_code: batch.batch_code,
              selected_batch: { ...batch },
              qty: take,
              entered_qty: take,
            });
          }
        }
      }

      // 3️⃣ finally push newly selected batches
      selected_batches.forEach(i => {
        addInvoiceItem(i);
        updateTotal();
      });
    })
  );
};


const check_item_duplication = (productCode, batchCode) => {
  const already_exists = invoiceItemsList.find(
    e => e.product_code === productCode && e.batch_code === batchCode
  );
  return !!already_exists;
};

  const addInvoiceItem = useCallback(invoiceItem => {
    setInvoiceItemsList(
      produce(draft => {
        //invoiceItem.deleted = false;
        draft.unshift(invoiceItem);
      })
    );
  }, []);

  const constructInvoiceItem = (itemToAdd) => {
    return {
        ...itemToAdd,
        selected_unit: itemToAdd.units, // 🔥 itemToAdd-இல் இருந்து Units-ஐ எடுக்கிறோம்
        qty: 0,
    };
};
// const totalItems = invoiceItemsList.length;
// const totalAmount = invoiceItemsList.reduce((acc, i) => acc + (i.total || 0), 0);
//   const totalPcs = invoiceItemsList
//     ?.filter(item => !isDecimalUnit(item.selected_unit))
//     .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

//   const totalKgs = invoiceItemsList
//     ?.filter(item => isDecimalUnit(item.selected_unit))
//     .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

const handleAddInvoiceItem = (productCode, batchCode = null, isScanner = false) => {
    const itemToAdd = productsList.find(e => e.code === productCode);
    if (!itemToAdd) {
        showErrorToast({ title: "Error", message: "Invalid product. Please select from list." });
        return;
    }

    let batchToSelect = null;
    
    // User oru batchCode kuduthirundha, adha select pannurom
    if (batchCode) {
        batchToSelect = itemToAdd.batches.find(b => b.batch_code.toLowerCase() === batchCode.toLowerCase());
        if (!batchToSelect) {
            showErrorToast({ title: "Error", message: `Batch '${batchCode}' not found.` });
            return;
        }
    } else {
        // Illana, default ah முதல் batch ah eduthukurom (idhu unga palaya functionality)
        batchToSelect = itemToAdd.batches[0];
    }

    if (!batchToSelect) {
        showErrorToast({ title: "Error", message: "Product has no available stock." });
        return;
    }


    const existingItem = invoiceItemsList.find(
    e => e.product_code === itemToAdd.product_code && e.batch_code === batchToSelect.batch_code
  );

  if (existingItem) {
  if (isScanner) {
    const newQty = (parseFloat(existingItem.entered_qty) || 0) + 1;
    if (newQty > existingItem.selected_batch.stock) {
        showErrorToast({
          title: "Insufficient Stock",
          message: `Only ${existingItem.selected_batch.stock} units available`
        });
        setTimeout(() => {
      document.getElementById("temp_qty_input")?.focus();
      document.getElementById("temp_qty_input")?.select();
    }, 100);
        return;
      }
    setInvoiceItemsList(
      produce(draft => {
        const item = draft.find(
          x =>
            x.product_code === itemToAdd.product_code &&
            x.batch_code === batchToSelect.batch_code
        );
        if (item) {
          item.entered_qty = newQty;
          item.qty = newQty;
        }
      })
    );
    updateTotal();
    return;
  } else {
    showErrorToast({
      title: "Error",
      message: "This product and batch combination is already in the list.",
    });

    // 🔒 Prevent Select box from stealing focus again
    setLockFocus(true);

    // Wait until React re-renders (invoice table already visible)
    setTimeout(() => {
      const qtyInputWrapper = document.getElementById(
        `qty_input_${itemToAdd.code}_${batchToSelect.batch_code}`
      );

      if (qtyInputWrapper) {
        // Mantine renders <div id="..."><input /></div>
        const inputEl =
          qtyInputWrapper.querySelector("input") || qtyInputWrapper;
        inputEl.focus();
        inputEl.select?.();
      }

      // 🔓 Release lock slightly later to avoid race with Mantine Select
      setTimeout(() => setLockFocus(false), 500);
    }, 250);

    return;
  }
}


    

//     if (check_item_duplication(itemToAdd.product_code, batchToSelect.batch_code)) {
//   showErrorToast({ title: "Error", message: "This product and batch combination is already in the list." });
//   return;
// }
    
    // IMPORTANT: Inga namba constructInvoiceItem use pannama, batchToSelect vechu manual ah newItem create panrom
    const newItem = {
        ...itemToAdd,
        selected_unit: itemToAdd.units,
        precision: isDecimalUnit(itemToAdd.units) ? 3 : 0,   // <-- added
        allowDecimal: isDecimalUnit(itemToAdd.units),
        selected_batch: batchToSelect,
        batch_code: batchToSelect.batch_code,
        qty: 0,
        entered_qty: 0,
        total: 0,
        basic_amount: 0,
        tax_total: 0,
        discount: 0,
        discountPercentage: 0,
        deleted: false,
        id: null,
    };
    addInvoiceItem(newItem);

    // Qty input-ku focus panna idhu thevai
    setSelectValue(productCode);
    setFocus(true);
  };

  const deleteInvoiceItem = useCallback((uniqueId) => {
    console.log("Invoice Items List Before Deletion:", invoiceItemsList, uniqueId);
  // Find the item first to get the correct product_code and batch_code
  const itemToDelete = invoiceItemsList.find(item => 
    `${item.product_code}_${item.batch_code}` === uniqueId
  );

  if (!itemToDelete) {
    console.error("Item not found for deletion:", uniqueId);
    return;
  }

  const product_code = itemToDelete.product_code;
  const batch_code = itemToDelete.batch_code;
  const itemId = itemToDelete.id;

  console.log("Delete function :: Product Code:", product_code, "Batch Code:", batch_code);
      setInvoiceItemsList(
    produce((draft) => {
      const index = draft.findIndex((item) => 
        item.product_code === product_code && item.batch_code === batch_code
      );

      if (index === -1) {
        console.error("Item not found in draft");
        return;
      }

      // Remove the item from the invoice list
      draft.splice(index, 1);
    })
  );

        // Store deleted item IDs separately
        if (itemId) {
          console.log("Deleting Invoice Item ID:", itemId);
          setDeletedItems(
            produce((deletedDraft) => {
              deletedDraft.push(itemId);
            })
          );
        }

        // Now update the batches state safely
        setBatches(
          produce((batchDraft) => {
            const product = batchDraft.find((e) => e.product_code === product_code);
            if (!product) return; // Prevent errors if product not found

            console.log("Found Product for Reset:", current(product));

            const batchIndex = product.batches.findIndex((x) => x.batch_code === batch_code);
            if (batchIndex !== -1) {
              product.batches[batchIndex].stock = product.batches[batchIndex].total_stock;
            }
          })
        );
      
   
    updateTotal();
  }, [invoiceItemsList]);

  const deliverInvoice = async id => {
    if (id) {
      await invoice_api.deliver_invoice(id).then(res => {
        console.log(res.data);
        if (res.data.success) {
          showSuccessToast({
            title: "Success",
            message: "Item marked as delivered",
          });
        } else {
          showErrorToast({
            title: "Error",
            message: res.data.message,
          });
        }
      });
    }
  };

  const submitInvoice = useMutation({
    mutationFn: data => invoice_api.submit_invoice(data),
    onSuccess: data => {
      // console.log('qqq-1234', data, data.data.data);
      if (data.data.success) {
        setInvoicesId(data.data.data);
        setInvoicesData(data.data.data.data);
        // console.log('qqq-1', invoicesData);
        console.log(data.data);
        setPaymentReceiptData({
          invoice: data.data.data.id,
          invoice_id: data.data.data.invoice_id,
          total: +getTotal("amount").toFixed(2),
        });
        showSuccessToast({ title: "Success", message: data.data?.message });
        if (payAndPrintBill) {
          setPaymentReceiptFormVisible(true);
          deliverInvoice(data.data.data.id)
        }

        if (!payAndPrintBill) {
          navigate("/invoices");
        }
      } else {
        showErrorToast({ title: "Warning", message: data.data?.message });
      }
    },
    onError: () => {
      showErrorToast({ title: "Error", message: "Error submitting invoice." });
    },
  });

  const editInvoice = useMutation({
    mutationFn: data => invoice_api.edit_invoice(data),
    onSuccess: data => {
      console.log('qqq-1234', data, data.data.data);
      if (data.data.success) {
        setInvoicesId(data.data);
        setInvoicesData(data.data.data);
        setPaymentReceiptData({
          invoice: data.data.data.id,
          invoice_id: data.data.data.invoice_id,
          total: +getTotal("amount").toFixed(2),
        });
        showSuccessToast({ title: "Success", message: data.data?.message });
        // if (payAndPrintBill) {
        //   printInvoice(data.data.data);
        // }

        if (payAndPrintBill) {
          setPaymentReceiptFormVisible(true);
        }

        if (!payAndPrintBill) {
          navigate("/invoices");
        }
      } else {
        showErrorToast({ title: "Warning", message: data.data?.message });
      }
    },
    onError: () => {
      showErrorToast({ title: "Error", message: "Error editting invoice." });
    },
  });
  const printInvoice = data => {
    console.log('qqq-123', data);
    const item = data.invoice_item.map(e => {
      return `<div style="white-space: nowrap;">
            <p  style="display: inline-block;width: 55%;padding:0px;">${e.product}</p> 
            <p  style="display: inline-block;width: 10%;text-align:right;padding:0px;">${e.mrp.toFixed(
        2
      )} &emsp; </p> 
            <p  style="display: inline-block;text-align:center;width: 35%;padding:0px;">${e.batch_no
        }</p> 
           <br/> 
            <p  style="display: inline-block;width: 10%;text-align:right;padding:0px;">${e.qty}</p> 
            <p  style="display: inline-block;width: 30%;text-align:right;padding:0px;">${e.rate.toFixed(
          2
        )}</p>
            <p  style="display: inline-block;width: 10%;text-align:right;padding:0px;">${e.tax
        }%</p> 
            <p  style="display: inline-block;width: 10%;text-align:right;padding:0px;">${e.discount
        }%</p> 
            <p  style="display: inline-block;width: 30%;text-align:right;padding:0px;">${e.amount.toFixed(
          2
        )}</p> 
        </div>`;
    });

    const qty = data.invoice_item.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.qty;
    }, 0);
    const items = item.join("");
    const printWindow = window.open("", "", "width=600,height=600");
    printWindow.document.open();
    printWindow.document.write(printTemplate(data, items, moment, qty));
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    navigate("/invoices");
  };

  const saveInvoice = (type) => {
    const savedInvoiceItems = JSON.parse(sessionStorage.getItem("invoiceItems")) || [];
    const savedCustomerId = sessionStorage.getItem("customerId") || "";
    const savedCouponApplied = JSON.parse(sessionStorage.getItem("couponApplied")) || {};
    const savedPackingCharge = sessionStorage.getItem("packingCharge") || 0;

    setInvoiceItemsList(savedInvoiceItems);
    setCustomerId(savedCustomerId);
    setCouponApplied(savedCouponApplied)
    setPackingCharge(savedPackingCharge)

    if (savedCustomerId && savedInvoiceItems?.length > 0 && savedInvoiceItems.some(item => item.qty === 0)) {
      showErrorToast({ title: "Error", message: "One or more items have qty set to 0" });
      return;
    }

    let coupon =
      savedCouponApplied?.coupon_type === "Flat"
        ? Number(getTotal("amount", savedInvoiceItems, savedCouponApplied, savedPackingCharge) * (savedCouponApplied?.value / 100)).toFixed(2)
        : Number(savedCouponApplied?.value).toFixed(2);
    coupon = isNaN(coupon) ? 0 : parseFloat(coupon).toFixed(2);

    const invoice_items = savedInvoiceItems.map(e => {
      return {
        id: e.id,
        counter_stock_id: e.counter_stock_id,
        counter_stock_batch_id: e.selected_batch.id,
        qty: e.qty,
        rate: e?.selected_batch.price,
        amount: e.total,
        discount: e.discountPercentage,
        discount_amount: e.discount + Number(coupon),
        tax: e.tax,
        tax_amount: e.tax_total,
      };
    });

    console.log({ invoice_items });

    let payload = {};

    if (savedCouponApplied?.id) {
      payload = {
        invoice: {
          sub_total: +getTotal("subtotal", savedInvoiceItems, savedCouponApplied, savedPackingCharge),
          tax_total: +getTotal("tax", savedInvoiceItems, savedCouponApplied, savedPackingCharge).toFixed(2),
          discount_total: +getTotal("discount", savedInvoiceItems, savedCouponApplied, savedPackingCharge),
          total: +getTotal("amount", savedInvoiceItems, savedCouponApplied, savedPackingCharge),
        },
        customer_id: savedCustomerId,
        invoice_item: invoice_items,
        deleted_array: deletedItems,
        coupon_id: savedCouponApplied.id ? savedCouponApplied.id : null,
        coupon_amount: Number(coupon),
        discount_total: Number(getTotal("discount", savedInvoiceItems, savedCouponApplied, savedPackingCharge)),
      };
    } else {
      payload = {
        invoice: {
          sub_total: +getTotal("subtotal", savedInvoiceItems, savedCouponApplied, savedPackingCharge),
          tax_total: +getTotal("tax", savedInvoiceItems, savedCouponApplied, savedPackingCharge).toFixed(2),
          discount_total: +getTotal("discount", savedInvoiceItems, savedCouponApplied, savedPackingCharge),
          total: +getTotal("amount", savedInvoiceItems, savedCouponApplied, savedPackingCharge),
        },
        customer_id: savedCustomerId,
        invoice_item: invoice_items,
        deleted_array: deletedItems,
        coupon_amount: Number(coupon),
        discount_total: Number(getTotal("discount", savedInvoiceItems, savedCouponApplied, savedPackingCharge)),
      };
    }

    if (savedInvoiceItems.length > 0 && savedCustomerId) {
      if (isEditing || type == 'edit') {
        let p = payload;
        // p.id = searchParams.get("id");
        p.invoice.id = searchParams.get("id");
        editInvoice.mutate(payload);
      } else {
        setInvoiceTotal(payload.invoice.total);

        console.log('qqq-234', payload)

        submitInvoice.mutate(payload);
      }
    } else {
      showErrorToast({ title: "Error", message: "Select customer / Please add invoice items." });
    }
  };

  // Fetching & Setting the data
  const invoice_items = useQuery("invoice-items-list", invoice_api.get_items, {
    onSuccess: data => {
      // console.log("API Response ->", data.data); 
      const modifiedData = data.data.map(e => {
        const stock_filled_batch = e.counter_batch.filter(e => e.stock > 0);
        // console.log('000',e)
        return {
          counter_stock_id: e.id,
          product_code: e.product,
          code: e.product_code,
          product_name: e.title,
          tax: e.tax || 0,
          price: e.selling_price,
          mrp: e.mrp,
          units: e.units,
          total_avl_stock: stock_filled_batch?.reduce((sum, product) => sum + (product.stock || 0), 0),
          batches: stock_filled_batch.map(x => {
            return {
              id: x.id,
              batch_code: x.batch_no,
              expiry_date: x.exp_date,
              stock: x.stock,
              total_stock: x.stock,
              code: e.product_code,
              mrp: x.mrp,
              price: x.selling_price,
            };
          }),
        };
      });
      setProductsList(getModifiedList(modifiedData));
      setProductsSearchList(getModifiedList(modifiedData));
      setBatches(
        modifiedData.map(e => {
          return {
            product_code: e.product_code,
            batches: e.batches,
          };
        })
      );

      // Edit functionalities

      if (window.location.pathname.includes("/edit")) {
        setIsEditing(true);
        invoice_api.get_invoice_by_id(searchParams.get("id")).then(res => {
          const data = res.data.data;
          setPackingCharge(data.packing_charge);

          const products_list = getModifiedList(modifiedData);

          for (let item of data.invoice_item) {
            console.log("I am an item here", item);

            const product = products_list.find(e => e.product_code === item.product);

            console.log(products_list);

            if (product) {
              console.log({
                product,
              });

              const itemToAdd = p => {
                return {
                  ...p,
                  id: item.id,
                  box: 0,
                  pieces: 0,
                  free_samples: 0,
                  discount: item.discount_amount,
                  discountPercentage: item.discount,
                  qty: item.qty,
                  entered_qty: item.qty,
                  total: item.amount,
                  basic_amount: 0,
                  tax_total: item.tax_amount,
                  selected_unit: item.units,
                  counter_stock: item.counter_stock ? item.counter_stock : item.batch.stock,
                  batch_code: item.batch_no,
                  mrp: item?.mrp,
                  price: item?.selling_price,
                  selected_batch: {
                    id: item.counter_stock_batch ? item.counter_stock_batch : item.batch.id,
                    batch_code: item.batch_no,
                    batch_no: item.batch_no,
                    mrp: item?.batch?.mrp,
                    price: item?.batch?.selling_price,
                    expiry_date: item.counter_stock_batch
                      ? p.batches.find(e => e.batch_code === p.batch_code)?.expiry_date
                      : item.batch.exp_date,
                    stock: item.counter_stock ? item.counter_stock : item.batch.stock,
                    total_stock: item.counter_stock ? item.counter_stock : item.batch.stock,
                  },
                };
              };
              const batchLessItemToAdd = prod => {
                let fulfilled_stock = 0;
                const selected_batches = [];
                let batches = prod.batches;
                let total_stock_needed = item.qty;

                for (let batch of batches) {
                  let needed_stock = total_stock_needed - fulfilled_stock;
                  if (fulfilled_stock >= total_stock_needed) {
                  } else {
                    if (batch.stock > 0) {
                      if (batch.stock > needed_stock) {
                        fulfilled_stock += needed_stock;
                        batch.stock = batch.stock - needed_stock;
                        selected_batches.push({
                          ...prod,
                          id: item.id,
                          box: 0,
                          pieces: 0,
                          free_samples: 0,
                          discount: item.discount_amount,
                          discountPercentage: item.discount,
                          qty: needed_stock,
                          entered_qty: needed_stock,
                          total: item.amount,
                          basic_amount: 0,
                          tax_total: item.tax_amount,
                          selected_unit: item.units,
                          counter_stock: batch.stock,
                          batch_code: batch.batch_code,
                          selected_batch: {
                            ...batch,
                            mrp: item?.batch?.mrp,
                            price: item?.batch?.selling_price,
                            stock: batch.total_stock - needed_stock,
                          },
                        });
                      } else {
                        const current_stock = batch.stock;
                        fulfilled_stock += current_stock;
                        batch.stock = 0;
                        selected_batches.push({
                          ...prod,
                          id: item.id,
                          box: 0,
                          pieces: 0,
                          free_samples: 0,
                          discount: item.discount_amount,
                          discountPercentage: item.discount,
                          qty: current_stock,
                          entered_qty: current_stock,
                          total: item.amount,
                          basic_amount: 0,
                          tax_total: item.tax_amount,
                          selected_unit: item.units,
                          counter_stock: batch.stock,
                          batch_code: batch.batch_code,
                          selected_batch: {
                            ...batch,
                            mrp: item?.batch?.mrp,
                            price: item?.batch?.selling_price,
                            stock: 0,
                          },
                        });
                      }
                    }
                  }
                }
                if (selected_batches) {
                  for (let i of selected_batches) {
                    addInvoiceItem(i);
                  }
                }
              };

              // console.log("product", itemToAdd(product));

              console.log("data", data);
              setCustomerId(data.user);

              let coupon = coupons.find(value => value.id === data.coupon);
              console.log(coupon);
              setCouponApplied(coupon);

              setCouponCode(coupon);
              // setCouponCode({ coupon_code: coupon.coupon_code });
              // applyCoupon(true);
              if (item.batch || item.counter_stock) {
                addInvoiceItem(itemToAdd(product));
              } else {
                batchLessItemToAdd(product);
              }
              updateTotal();
              // handleAddInvoiceItem(product.batch_code);
            }
          }
        });
      }
    },
  });

  const SelectItem = forwardRef(({ image, label, description, ...others }, ref) => (
    <div {...others}>
      <Group noWrap>
        <Avatar src={image} />
        <div>
          <Text size="sm">{label}</Text>
          <Text size="xs" opacity={0.65}>
            {description}
          </Text>
        </div>
      </Group>
    </div>
  ));

  // Customer selection component validation
  const customer_ref = useRef(null);
  const handleCustomerSelection = value => {
    setMobileNumberErrorMessage(null);
    console.log(value);
    if (value) {
      setCustomerId(value);
      const customer = customers.filter(cus => cus.id === value);
      console.log(customer);

      setCustomerSelected(customer);
      setTimeout(() => {
        customer_ref.current?.blur();
      }, 100);
      setTimeout(() => {
        handleQtyOnFocus();
      }, 150);
    }
  };

  // Printing
  const navigateToPrint = () => {
    const invoice_items = invoiceItemsList.map(e => {
      return {
        id: e.id,
        counter_stock_id: e.selected_batch.id,
        counter_stock_batch_id: e.selected_batch.id,
        qty: e.qty,
        rate: e.price,
        amount: e.total,
        discount_amount: e.discount,
        tax: e.tax,
        tax_amount: e.tax_total,
      };
    });

    const payload = {
      invoice: {
        sub_total: +getTotal("subtotal"),
        tax_total: +getTotal("tax").toFixed(2),
        discount_total: +getTotal("discount"),
        total: +getTotal("amount"),
      },
      customer_id: customerId,
      invoice_item: invoice_items,
    };
    navigate("/invoices/print", {
      state: payload,
    });
  };

  const qty_ref = useRef(null);
  const handleQtyOnFocus = () => {
    qty_ref.current?.focus();
  };

  const handleSubmit = (type) => {
    console.log("F5 pressed");
    saveInvoice(type);
  };

  const lastRef = useRef(null);

  useEffect(() => {
    if (lastRef.current) lastRef.current.focus();
  }, [invoiceItemsList.length]);

  const getExpiryDayLeft = expiry_date => {
    const expirationDate = new Date(expiry_date);
    const currentDate = new Date();
    const timeDifference = expirationDate.getTime() - currentDate.getTime();
    return Math.ceil(timeDifference / (1000 * 3600 * 24));
  };

  const optionsFilter = (value, item) => {
    if (!value) return true;
    const searchValue = value.toLowerCase().trim();
    const productCodeToSearch = searchValue.split('-')[0];
    return (
        item.label.toLowerCase().includes(searchValue) || 
        item.code?.toLowerCase().includes(productCodeToSearch)
    );
  };
  useEffect(() => {
  const handleKeyDown = (event) => {
    if (event.key === "F2") {
      event.preventDefault();

      // Run your existing focus helper
      setTimeout(() => {
        handleQtyOnFocus();

        // Optional: also open dropdown if you want
        const wrapper = qty_ref.current;
        if (wrapper) {
          const controlEl = wrapper.querySelector("[data-mantine-select-target]");
          if (controlEl) {
            controlEl.click(); // open dropdown
          }
        }
      }, 30);
    }

  if (event.key === "F3") {
      event.preventDefault();
      setTimeout(() => {
        const couponInput = document.querySelector('input[placeholder*="Enter Coupon Code"]');
        if (couponInput) {
          couponInput.focus();
          couponInput.select();
        }
      }, 30);
    }

    if (event.key === "F4") {
      event.preventDefault();
      setTimeout(() => {
        const discountInput = document.querySelector('input[placeholder*="Enter net discount"]');
        if (discountInput) {
          discountInput.focus();
          discountInput.select();
        }
      }, 30);
    }

    // Tab navigation - when tab reaches list
    if (event.key === 'Tab' && isListFocused && !selectedRow && invoiceItemsList.length > 0) {
      // Auto-select first row when tab enters the list
      const firstItem = invoiceItemsList[0];
      const firstUniqueId = `${firstItem.product_code}_${firstItem.batch_code}`;
      setSelectedRow(firstUniqueId);
      event.preventDefault(); // Keep focus in the list
    }
    
    // Arrow key navigation for rows (only when list is focused)
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && isListFocused) {
      event.preventDefault();
      handleArrowKeyNavigation(event.key);
    }
  // Enter key for selected row editing
    if (event.key === 'Enter' && selectedRow && isListFocused && !isEditingMode) {
      event.preventDefault();
      const selectedItem = invoiceItemsList.find(item => 
        `${item.product_code}_${item.batch_code}` === selectedRow
      );
      if (selectedItem) {
        handleEditItem(selectedItem);
      }
    }
  // Tab to exit list
    if (event.key === 'Tab' && isListFocused && selectedRow && event.shiftKey === false) {
      // Allow normal tab behavior to move to next element
      setIsListFocused(false);
      setSelectedRow(null);
    }


  };
  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [selectedRow, isEditingMode, invoiceItemsList, isListFocused]);


  useEffect(() => {
    const preventRefresh = (event) => {
      // if (event.key === "F5" || (event.key === "Enter" && event.target.tagName !== "TEXTAREA")) {
      //   event.preventDefault();
      //   const savedInvoiceItems = JSON.parse(sessionStorage.getItem("invoiceItems")) || [];
      //   const savedCustomerId = sessionStorage.getItem("customerId") || "";

      //   setInvoiceItemsList(savedInvoiceItems);
      //   setCustomerId(savedCustomerId);

      // }

      // if (event.key === "F4" || event.key === "F5") {
      if (event.key === "F5" && event.altKey) {
        event.preventDefault();

        // Set editing state based on the path
        const isEditPage = window.location.pathname.includes("/edit");
        setIsEditing(isEditPage);

        // Reset 'Pay and Print Bill' state
        // if (event.key === "F4") {
        //   setPayAndPrintBill(false);
        // } else 
          if (event.key === "F5"&& event.altKey) {
          setPayAndPrintBill(true);
        }

        // Handle the submit logic with timeout
        const handleSubmitWithDelay = () => {
          if (isEditPage) {
            handleSubmit('edit');
          } else {
            handleSubmit();
          }
        };


        const delay = 100;
        setTimeout(handleSubmitWithDelay, delay);
      }
      // if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
      //   event.preventDefault()
      //   handleQtyOnFocus()
      // }
    };

    window.addEventListener("keydown", preventRefresh);
    return () => {
      window.removeEventListener("keydown", preventRefresh);
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("invoiceItems", JSON.stringify(invoiceItemsList || []));

    sessionStorage.setItem("customerId", customerId || '');

    sessionStorage.setItem("couponApplied", JSON.stringify(couponApplied || {}))

    sessionStorage.setItem("packingCharge", packingCharge || 0)
  }, [invoiceItemsList, customerId, couponApplied, packingCharge]);

  

              console.log("Invoice Items List Before Deletion:", invoiceItemsList);


  return (
  
    <>
       {!isMobileScreen && ( 
        <Box 
        style={{  height: "100vh", // full height
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",}}>
      {/* ✅ STICKY HEADER */}
        <Box
        shadow="sm" radius="md" p="xs" withBorder
          style={{
            position: "fixed",
            flex: "0 0 auto",
            top: 145,
            marginTop: "3px", 
            marginLeft: "10px",
            bottom:400,
            right: 400,
            zIndex: 100,
            boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.18)",
            alignItems: "center",
            padding: "6px 10px",
            background: "#fff",
            borderBottom: "1px solid #ddd",
            borderRadius: "8px",
            width: "calc(100% - 420px)",
            height: "185px", // Fixed height to force reduction
            minHeight: "185px", // Prevent growing
            maxHeight: "185px", // Prevent expanding
           }}
        >
        <Container fluid >
        {/* <Card shadow="sm" radius="md" p="sm" withBorder style={{ padding:"6px 10px",  marginBottom: 0  }} > */}
            <Flex justify={"space-between"} align="start" >
          <Card>
                <Text size={"lg"} fw={600} >
                  Create Invoice
                </Text>
                <Breadcrumbs separator="/" sx={{ fontSize: 14 }}>
                  <Anchor href="/">Home</Anchor>
                  <Anchor href="/">Transactions</Anchor>
                  <Anchor>Invoice</Anchor>
                </Breadcrumbs>

        {/* Add Product Search Box */}
        <Group mt={6} align="center">
          {isEditingMode ? (
            <Text 
              fw={600} 
              color="white" 
              bg="yellow" 
              px={10} 
              py={5} 
              style={{ 
                borderRadius: '8px', 
                display: 'inline-block' 
              }}
            >
              Editing
            </Text>
          ) : (
            <Text fw={600}>
              Add Products
            </Text>
          )}


        <Select
          value={selectedProductName || ""}
          searchValue={selectedProductName ? selectedProductName : searchValue}
          onSearchChange={(val) => {
            if (!lockFocus) {
              setSearchValue(val);
            // Clear selected product when user starts typing
              if (val && selectedProductCode) {
                setSelectedProductCode(null);
                setSelectedProductName("");
                    }
                  }
                  }}
                  disabled={false}
                  icon={<IconSearch style={{ left: 10, width: 18 }} />}
                  placeholder={selectedProductName ? selectedProductName : "Click here to add Invoice Item (F2)"}
                  data={productsList?.sort((a, b) => a.label.localeCompare(b.label)) || []} 
                  ref={qty_ref}
                  searchable
                  withinPortal   
                  dropdownPosition="bottom"
                  styles={{
                    input: {
                      border: "1px solid #d8dce0ff",
                      borderRadius: "6px",
                     backgroundColor: isEditingMode ? "#fcf2daf7" : "white",
                    },
                  }}
                  maxDropdownHeight={120}
                  sx={{ flex: 1, fontSize: "14px", minWidth: "400px" }}
                  nothingFound="No products found"
                  filter={optionsFilter}
                  onChange={(productCode) => {
                  if (!productCode) return;
                  
                  // const selectedProduct = productsList.find(p => p.code === productCode);
                  // setSelectedProductCode(productCode);
                  // setSelectedProductName(selectedProduct?.label || ""); // Store product name
                  
                  let batchCode = null;
                  if (searchValue.includes("-")) {
                    const parts = searchValue.split("-");
                    if (parts[0] === productCode) {
                      batchCode = parts[1];
                    }
                  }
                  const selectedProduct = productsList.find(p => p.code === productCode);
                  if (!selectedProduct) return;
                  
                  // Auto-select first available batch
                  const firstAvailableBatch = selectedProduct.batches.find(batch => batch.stock > 0) || selectedProduct.batches[0];
                  
                  if (firstAvailableBatch) {
                    // ✅ CHECK IF PRODUCT+BATCH ALREADY EXISTS IN INVOICE - IMMEDIATELY!
                    const existingItem = invoiceItemsList.find(
                      item => item.product_code === selectedProduct.product_code && 
                      item.batch_code === firstAvailableBatch.batch_code
                    );
                    
                    if (existingItem) {
                      handleEditItem(existingItem);
                      showSuccessToast({
                        title: "Editing Mode Activated",
                        message: `You're now editing ${existingItem.product_name} (${existingItem.batch_code})`
                      });
                      
                      setSearchValue("");
                      return; // Stop further execution
                    }
      
                      // If not a duplicate, proceed with normal selection
                      setSelectedProductCode(productCode);
                      setSelectedProductName(selectedProduct?.label || "");
                      setSelectedBatchCode(firstAvailableBatch.batch_code);
                      setSelectedBatchName(firstAvailableBatch.batch_code);
                      
                      // Auto-focus to quantity input
                      setTimeout(() => {
                        document.getElementById("temp_qty_input")?.focus();
                        document.getElementById("temp_qty_input")?.select();
                      }, 100);
                    }
                    
                    setSearchValue("");
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" && searchValue) {
                      event.preventDefault();
                      let productCode = searchValue;
                      let batchCode = null;
                      if (searchValue.includes("-")) {
                        const parts = searchValue.split("-");
                        productCode = parts[0];
                        batchCode = parts[1];
                      }
                      const selectedProduct = productsList.find(p => p.code === productCode);
                      if (selectedProduct) {
                        const firstAvailableBatch = selectedProduct.batches.find(batch => batch.stock > 0) || selectedProduct.batches[0];
                        
                        if (firstAvailableBatch) {
                          // ✅ CHECK IF PRODUCT+BATCH ALREADY EXISTS IN INVOICE - IMMEDIATELY!
                          const existingItem = invoiceItemsList.find(
                            item => item.product_code === selectedProduct.product_code && 
                            item.batch_code === firstAvailableBatch.batch_code
                          );
                          
                          if (existingItem) {
                            handleEditItem(existingItem);
                            
                            // Show informative message
                            showSuccessToast({
                              title: "Editing Mode Activated",
                              message: `You're now editing ${existingItem.product_name} (${existingItem.batch_code})`
                            });
                            
                            setSearchValue("");
                            return; // Stop further execution
                          }
          
                          // If not a duplicate, proceed with normal selection
                          setSelectedProductCode(productCode);
                          setSelectedProductName(selectedProduct?.label || "");
                          setSelectedBatchCode(firstAvailableBatch.batch_code);
                          setSelectedBatchName(firstAvailableBatch.batch_code);
                          
                          // Auto-focus to quantity input
                          setTimeout(() => {
                            document.getElementById("temp_qty_input")?.focus();
                            document.getElementById("temp_qty_input")?.select();
                          }, 100);
                        }
                      }
                      
                      setSearchValue("");
                    }
                  }}
                />
                        
          {/* Batch Selection Button */}
          <Button
            variant="light"
            color="green"
            size="xs"
            onClick={() => {
              if (isEditingMode) {
                updateModalBatches(editingItem.product_code);
                setProductSelectionModal(true);
              } else if (!selectedProductCode) {
                showErrorToast({
                  title: "Error",
                  message: "Please select a product first!"
                });
                return;
              } else {
                updateModalBatches(selectedProductCode);
                setProductSelectionModal(true);
              }
            }}>
          <Badge
            sx={{
              color: (selectedBatchCode || (isEditingMode && editBatchCode)) ? "white" : "gray",
              borderColor: (selectedBatchCode || (isEditingMode && editBatchCode)) ? "blue" : "lightgray",
              fontSize: '10px',
              height: '20px',
              lineHeight: '20px',
              marginTop:"7px",
              marginLeft:"5px"
            }}
            variant={(selectedBatchCode || (isEditingMode && editBatchCode)) ? "filled" : "outline"}
            mb={5}
            disabled={!selectedProductCode && !isEditingMode}
          >
            {isEditingMode 
              ? (selectedBatchCode || editingItem?.batch_code || "Select Batch")
              : (selectedBatchCode || "Select Batch")
            }
          </Badge>
         
        </Button>

        {/* Quantity Input */}
        <Button variant="light" color="green" size="xs">
          <NumberInput
            id="temp_qty_input"
            decimalSeparator="."
            type="number"
            allowDecimal={isEditingMode ? 
              isDecimalUnit(productsList.find(p => p.product_code === editingItem?.product_code)?.units || "PCS") : 
              selectedProductCode ? isDecimalUnit(productsList.find(p => p.code === selectedProductCode)?.units || "PCS") : false
            }
            precision={isEditingMode ? 
              (isDecimalUnit(productsList.find(p => p.product_code === editingItem?.product_code)?.units || "PCS") ? 3 : 0) : 
              (selectedProductCode && isDecimalUnit(productsList.find(p => p.code === selectedProductCode)?.units || "PCS") ? 3 : 0)
            }
            step={isEditingMode ? 
              (isDecimalUnit(productsList.find(p => p.product_code === editingItem?.product_code)?.units || "PCS") ? 0.001 : 1) : 
              (selectedProductCode && isDecimalUnit(productsList.find(p => p.code === selectedProductCode)?.units || "PCS") ? 0.001 : 1)
            }
            value={isEditingMode ? editingItem?.qty || 0 : tempQty || ""}
            onChange={(val) => {
              if (isEditingMode) {
                setEditingItem(prev => ({...prev, qty: val}));
                        // ✅ IMMEDIATE VALIDATION ONLY FOR EDITING MODE
        if (val && val > 0) {
          const quantity = parseFloat(val) || 0;
          let totalAvailableStock = 0;
          
          const productBatch = batches.find(p => p.product_code === editingItem.product_code);
          if (productBatch?.batches) {
            const targetBatchCode = selectedBatchCode || editingItem.batch_code;
            const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
            if (selectedBatch) {
              totalAvailableStock += selectedBatch.total_stock || 0;
            }
            productBatch.batches.forEach(batch => {
              if (batch.batch_code !== targetBatchCode) {
                totalAvailableStock += batch.stock || 0;
              }
            });
          }
          totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));
          
          // ✅ IMMEDIATE ERROR ONLY FOR EDITING MODE
          if (quantity > totalAvailableStock) {
            showErrorToast({
              title: "Insufficient Stock",
              message: `Only ${totalAvailableStock} units available`
            });
            
            // ✅ KEEP FOCUS IN QTY INPUT FOR EDITING MODE
            setTimeout(() => {
              const qtyInput = document.getElementById("temp_qty_input");
                    if (qtyInput) {
                      qtyInput.focus();
                      qtyInput.select();
                    }
                  }, 100);
                }
              }
              } else {
                setTempQty(val);
              }
            }}
            size="xs"
            w={80}
            placeholder="Qty"
            disabled={!selectedBatchCode && !isEditingMode}
            
            // ✅ FIXED ONBLUR VALIDATION - Properly handle edit mode batch changes
            onBlur={(event) => {
              const enteredQty = parseFloat(event.target.value) || 0;
              
              if (enteredQty > 0) {
                let totalAvailableStock = 0;
                
                if (isEditingMode && editingItem) {
                      // For editing mode - get TOTAL stock across all batches
                      const productBatch = batches.find(p => p.product_code === editingItem.product_code);
                      if (productBatch?.batches) {
                        const targetBatchCode = selectedBatchCode || editingItem.batch_code;
                        
                        // Find the selected batch first
                        const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                        if (selectedBatch) {
                          // Add selected batch's TOTAL stock
                          totalAvailableStock += selectedBatch.total_stock || 0;
                          console.log(`Selected batch ${targetBatchCode}: total_stock = ${selectedBatch.total_stock}`);
                        }
                        
                        // Add other batches' CURRENT stock
                        productBatch.batches.forEach(batch => {
                          if (batch.batch_code !== targetBatchCode) {
                            totalAvailableStock += batch.stock || 0;
                            console.log(`Other batch ${batch.batch_code}: stock = ${batch.stock}`);
                          }
                        });
                        
                        console.log(`Total available: ${totalAvailableStock} (Selected batch total + Other batches current)`);
                      }
                    } else if (selectedBatchCode) {
                      // For new product mode: Same logic
                      const productToAdd = productsList.find(p => p.code === selectedProductCode);
                      const productBatch = batches.find(p => p.product_code === productToAdd?.product_code);
                      if (productBatch?.batches) {
                        const selectedBatch = productBatch.batches.find(b => b.batch_code === selectedBatchCode);
                        if (selectedBatch) {
                          totalAvailableStock += selectedBatch.total_stock || 0;
                        }
                        
                        productBatch.batches.forEach(batch => {
                          if (batch.batch_code !== selectedBatchCode) {
                            totalAvailableStock += batch.stock || 0;
                          }
                        });
                      }
                    }
                    
                    // Show error if quantity exceeds total available stock
                    if (enteredQty > totalAvailableStock) {
                      showErrorToast({
                        title: "Insufficient Stock",
                        message: `Only ${parseFloat(totalAvailableStock.toFixed(2))} units available`
                      });
                      
                      
                      // Reset to available stock
                      if (isEditingMode) {
                        setEditQty(totalAvailableStock);
                      } else {
                        setTempQty(totalAvailableStock);
                      }
                       setTimeout(() => {
                        document.getElementById("temp_qty_input")?.focus();
                        document.getElementById("temp_qty_input")?.select();
                      }, 100);
                      return;
                    }
                  }
                }}
                
              onKeyDown={(event) => {
              const currentUnit = isEditingMode ? 
              productsList.find(p => p.product_code === editingItem?.product_code)?.units : 
              productsList.find(p => p.code === selectedProductCode)?.units;
            
              if (!isDecimalUnit(currentUnit) && (event.key === "." || event.key === ",")) {
                  event.preventDefault();
                  alert("Decimals are not allowed for PCS/NOS units!");
                  return;
                }
                if (event.key === "Enter") {
                  event.preventDefault();
                  
                // ✅ FIXED VALIDATION - Properly handle edit mode batch changes
                const enteredQty = parseFloat(isEditingMode ? editQty : tempQty) || 0;
                let totalAvailableStock = 0;
                
                if (isEditingMode && editingItem) {
                  const productBatch = batches.find(p => p.product_code === editingItem.product_code);
                  if (productBatch?.batches) {
                    const targetBatchCode = selectedBatchCode || editingItem.batch_code;
                    
                    // Find the selected batch first
                    const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                    if (selectedBatch) {
                      // Add selected batch's TOTAL stock
                      totalAvailableStock += selectedBatch.total_stock || 0;
                    }
                    
                    // Add other batches' CURRENT stock
                    productBatch.batches.forEach(batch => {
                      if (batch.batch_code !== targetBatchCode) {
                        totalAvailableStock += batch.stock || 0;
                      }
                    });
                  }
                } else if (selectedBatchCode) {
                  const productToAdd = productsList.find(p => p.code === selectedProductCode);
                  const productBatch = batches.find(p => p.product_code === productToAdd?.product_code);
                  if (productBatch?.batches) {
                    const selectedBatch = productBatch.batches.find(b => b.batch_code === selectedBatchCode);
                    if (selectedBatch) {
                      totalAvailableStock += selectedBatch.total_stock || 0;
                    }
            
                    productBatch.batches.forEach(batch => {
                      if (batch.batch_code !== selectedBatchCode) {
                        totalAvailableStock += batch.stock || 0;
                      }
                    });
                  }
                }
                        
                if (enteredQty > totalAvailableStock) {
                  showErrorToast({
                    title: "Insufficient Stock",
                    message: `Only ${parseFloat(totalAvailableStock.toFixed(2))} units available`
                  });
                  setTimeout(() => {
                    document.getElementById("temp_qty_input")?.focus();
                    document.getElementById("temp_qty_input")?.select();
                  }, 100);
                  return;
                }
                
                if (isEditingMode) {
                  document.getElementById("temp_discount_input")?.focus();
                } else {
                  document.getElementById("temp_discount_input")?.focus();
                }
              }
            }}
          />
          Qty
        </Button>

        {/* Discount Input */}
          <Button variant="light" color="green" size="xs">
            <Flex align={"center"}>
              <NumberInput
                id="temp_discount_input"
                type="number"
                decimalSeparator="."
                precision={0}
                step={1}
                  onChange={(val) => isEditingMode ? 
                  setEditingItem(prev => ({...prev, discountPercentage: val})) : 
                  setTempDiscount(val)
                }
                value={isEditingMode ? 
                  (editingItem?.discountPercentage || 0) : 
                  (tempDiscount || "")
                }
                placeholder="Disc %"
                min={0}
                max={100}
                size="xs"
                w={60}
                disabled={!selectedBatchCode && !isEditingMode}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    document.getElementById("temp_enter_button")?.focus();
                  }
                }}
              />
          </Flex>
          Dis
        </Button>

        {/* Enter Button */}
        <Button
          id="temp_enter_button"
          color={isEditingMode ? "yellow" : "green"}
          size="xs"
          disabled={(!selectedBatchCode && !isEditingMode) || !tempQty}
          onClick={isEditingMode ? handleEditEnter : handleAddProductEntry}
        >
          Enter
        </Button>

          {/* Clear Button - Clears only current selection */}
          <Button
            variant="outline"
            color="orange"
            size="xs"
            onClick={isEditingMode ? cancelEdit : handleClearSelection}
            disabled={!selectedProductCode && !selectedBatchCode && !tempQty && !tempDiscount}
            title={isEditingMode ? "Cancel editing and restore original" : "Clear current product selection"}
            tabIndex={0}
          >
            <IconX size={14} />
            Clear
          </Button>
        </Group>
        </Card>
       
          {/* RIGHT SECTION */}
              <Flex gap="md" align="stretch" style={{ flex: 1, justifyContent: "flex-end" }}>
           {/* Coupon Card */}
              <Card shadow="sm" radius="md" p="xs" withBorder 
              style={{
                width: "220px",
                height: "170px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}>
                <Text fw={600} mb="xs"size="sm" color="orange.7">
                  <Group spacing="xs">
                    <IconTag size={14} />
                    Enter Coupon
                  </Group>
                </Text>
                <Box>
                  <TextInput
                    size="xs"
                    min={0}
                    label="Coupon Code"
                    placeholder="Enter Coupon Code (F3)"
                    rightSection={
                      <Tooltip label="Clear Coupon">
                        <Flex style={{ alignItems: "center", justifyContent: "center" }}>
                          <IconX
                            style={{ width: 16 }}
                            onClick={() => {
                              applyCoupon(false);
                              setCouponCode({ coupon_code: "" });
                            }}
                          />
                        </Flex>
                      </Tooltip>
                    }
                    value={
                      couponCode !== null && couponCode !== undefined
                        ? couponCode.coupon_code
                        : ""
                    }
                    onChange={val => {
                      setCouponCode({ coupon_code: val.target.value });
                    }}
                  />
                   
                  <Button
                    variant="outline"
                    size="xs"
                     w={"100%"}
                   mt={7}
                    onClick={() => {
                      applyCoupon(true);
                    }}
                  >
                    Apply Coupon
                  </Button>
                  <Button
                    variant="subtle"
                    size="11px"
                     w={"100%"}
                    mt={0}
                    onClick={e => setCouponsModalOpened(true)}
                  >
                  Show All Coupons
                  </Button>
                </Box>
              </Card>

              {/* Discount Card */}
              <Card shadow="sm" radius="md" p="xs" withBorder 
              style={{
                width: "220px",
                height: "170px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                  }}>
                <Text fw={600} mb="xs" size="sm" color="red.7">
                  <Group spacing="xs">
                    <IconDiscount2 size={14} />
                    Net Discount
                  </Group>
                </Text>
                <Box>
                  <NumberInput
                    decimalSeparator="."
                    precision={2}
                    step={0.01}
                    type="number"
                    size="xs"
                    min={0}
                    label="Net Discount ( % )"
                    placeholder="Enter net discount % (F4)"
                    onChange={val => {
                    console.log(val);
                      setNetDiscount(val);
                    }}
                  />
                  <Button
                    variant="outline"
                    size="xs"
                    mt={8}
                    w={"100%"}
                    onClick={applyNetDiscount}
                  >
                    Apply Net Discount
                  </Button>
                  <Text size="9px" color="red" mt={4}>
                    Note: Applying Net discount will overwrite existing discount in the list.
                  </Text>
                </Box>
              </Card>
              </Flex>
            </Flex>
       
          {/* </Card> */}
        </Container></Box>
      </Box>
      )}
          {/* Customer Card */}
                <Card shadow="sm" radius="md" p="xs" withBorder 
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "145px", // Adjust based on your layout
                  width: "360px",
                  height: "188px",
                  overflow: "visible",
                  boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.18)",
                  // zIndex: 10,
                }}>
                  {/* <Group position="apart" align="center" > */}
                    {/* <Text fw={600} size="md">
                      Invoice No
                    </Text> */}
                    <Box mb="sm" style={{ position: "relative" }}>
                         <div style={{
                        position: "absolute",
                        top: "-6px",
                        left: "12px",
                        // transform: "translateX(-50%)",
                        fontSize: "14px",
                        backgroundColor: "white",
                        padding: "0 4px",
                        zIndex: 2,
                        color: "black",
                        pointerEvents: "none",
                        fontWeight: "bold", 
                        fontFamily: "inherit"
                      }}>
                        Invoice ID
                      </div>
                    <TextInput
                      size="sm"
                      // label="Invoice ID"
                      placeholder="Invoice number"
                      value={invoicesId || ""}
                      disabled
                      styles={{
                        input: {
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e9ecef",
                          fontWeight: "600",
                          textAlign: "right",
                          '&::placeholder': {
            fontWeight: '700',
            color: '#000000',
            opacity: 1,
          }
                        },
                        label: {
                          fontSize: "12px",
                          marginBottom: "4px",
                          
                        },
                        root: {
                          marginTop: 0
                        }
                      }}
                    />
                  </Box>
                  
                  <Box mb="sm" style={{ position: "relative" }}>
                    <div style={{
                      position: "absolute",
                      top: "-6px",
                      left: "12px",
                      // transform: "translateX(-50%)",
                      fontSize: "13px",
                      backgroundColor: "white",
                      padding: "0 4px",
                      zIndex: 2,
                      color: "black",
                      pointerEvents: "none",
                      fontWeight: "bold", 
                      fontFamily: "inherit"
                    }}>
                      Invoice Date
                    </div>
                    <DatePickerInput
                        placeholder="Select Invoice date"
                        label=""
                        size="sm"
                        styles={{
                          input: {
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef",
                            textAlign: "right",
                            '&::placeholder': {
            fontWeight: '700',
            color: '#000000',
            opacity: 1,
          }
                          },
                          root: {
                            marginTop: 0
                          }
                        }}
                        data={[]}
                        disabled
                        {...form.getInputProps("date")}
                      ></DatePickerInput>
                       </Box>

                
                <CustomerSelection
                  reference={customer_ref}
                  id={customerId}
                  autoFocus={!location.pathname.includes("edit")}
                  onChange={handleCustomerSelection}
                  error={mobileNumberErrorMessage}
                  setError={setMobileNumberErrorMessage}
                  setCustomers={setCustomers}
                  withinPortal
                  dropdownPosition="bottom"
                  styles={{ dropdown: { zIndex: 9999 } }}
                  />
                  </Card>

{/* ✅ Main Content (fills between header & footer) */}
                  <Box
                    style={{
                      position: "absolute",
                      top: 340, // below header
                      bottom: "50px", // above footer
                      left: 0,
                      right: 0,
                      overflow: "hidden", // no full-page scroll
                    }}
                  >
              <Container fluid 
                  style={{
                        height: "100%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "stretch",
                        padding: "0 16px",
                      }}>
            <Grid gutter="lg" style={{ flex: 1, overflow: "hidden" }}>

    {/* Left Panel - Products List */}
    <Col span={isMobileScreen ? 12 : 9}style={{ display: "flex", flexDirection: "column",height: "100%", }}>
              <Card shadow="sm" radius="md" p="md" withBorder 
                    style={{flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    overflow: "hidden",
                    margin: 0,
                    }}>
        {/* <Text fw={600} mb="md" >Invoice Items List</Text> */}

              {/* ✅ Internal Scroll Only */}
                  <Box
                  style={{
                    flex: 1,
                    overflowY: "auto",       // scroll only inside
                    overflowX: "hidden",
                    height: "100%",
                    paddingRight: "4px",
                  }}
                >
                <Table
                  key={invoiceItemsList}
                  withColumnBorders
                  withBorder
                  striped
                  highlightOnHover
                  fontSize="sm"
                  verticalSpacing={"xs"}
                  horizontalSpacing={"sm"}
                  tabIndex={0}
                  onFocus={() => setIsListFocused(true)}
                  onBlur={() => setIsListFocused(false)}
                  sx={theme => ({
                    background: "white",
                    borderRadius: 2,
                    thead: { tr: { background: theme.colors.brand[1] } },
                        'tbody tr': {
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: theme.colors.red[0] + '!important', // Light gray on hover
                        }
                      },
                       '&:focus': {
                        outline: 'none'
                      }
                  })}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Product</th>
                      <th>Batch</th>
                      <th>BB</th>
                      <th>Avl.Stock</th>
                      <th>MRP ₹ </th>
                      <th>Basic Amount ₹ </th>
                      <th>Rate ₹ </th>
                      <th>Qty</th>
                      <th>Disc %</th>
                      <th>Disc. Amount ₹</th>
                      <th>Total ₹</th>
                      {/* <th>Edit</th> */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                  {invoiceItemsList.map((e, index) => {
                    if (!e.deleted) {
                     const uniqueId = `${e.product_code}_${e.batch_code}`;
                     const isEditingThisItem = editingItem?.uniqueId === uniqueId;
                     const isSelected = selectedRow === uniqueId;
                      return (
                        <tr 
                        key={uniqueId} 
                        style={{ 
                          fontWeight: '500',
                          backgroundColor: isEditingThisItem ? '#fff3cd' : 
                                        isSelected ? '#e3f2fd' : 'transparent',
                          cursor: 'pointer',
                          borderLeft: isSelected ? '4px solid #228be6' : 'none',
                          // Enhanced focus for keyboard navigation
                          outline: isSelected && isListFocused ? '2px solid #fd7e14' : 'none',
                          outlineOffset: '-2px'
                        }}
                        onClick={() => handleRowClick(uniqueId, e)}
          >
                          <td style={{width: "5%"}}>{index + 1}</td> 
                          
                          <td style={{ width: "200px" }}>
                            {isEditingThisItem && editStep === 'batch' ? (
                              <TextInput
                                value={editProductName}
                                readOnly
                                size="xs"
                                styles={{
                                  input: {
                                    backgroundColor: '#f8f9fa',
                                    fontWeight: 'bold'
                                  }
                                }}
                              />
                            ) : (
                              e.product_name
                            )}
                          </td>
                          
                          <td style={{ maxWidth: 140 }}>
                          <Badge
                            sx={{
                              color: "gray",
                              borderColor: "lightgray",
                              cursor: "pointer",
                            }}
                            variant={"outline"}
                            mb={5}
                            onClick={() => {
                              e.stopPropagation();
                              setCurrentBatch(e.selected_batch);
                              updateModalBatches(e.product_code,e.entered_qty);
                              setProductSelectionModal(true);
                            }}
                          >
                            {e.batch_code}
                          </Badge>
                        </td>
          
                          <td> {getExpiryDayLeft(e.selected_batch.expiry_date)}</td>

                          <td width={70} style={{textAlign: 'right'}}>{e?.total_avl_stock?.toFixed(3)}</td>
                          
                          <td width={70} style={{textAlign: 'right'}}> {e?.selected_batch?.mrp?.toFixed(2)}</td>

                          <td style={{textAlign: 'right'}}>{+e?.basic_amount?.toFixed(2)}</td>
                          
                          <td style={{textAlign: 'right'}}>  {e?.selected_batch?.price.toFixed(2)}</td>
                          
                          <td style={{ textAlign: "center" }}>
                            {isEditingThisItem && (editStep === 'qty' || editStep === 'disc') ? (
                              <NumberInput
                                id={`qty_input_${uniqueId}`} 
                                decimalSeparator="."
                                // precision={3} // Allows values like 0.500
                                // step={0.001} // Enables small decimal increments
                                type="number"
                                allowDecimal={isDecimalUnit(e.selected_unit)} 
    
                                precision={isDecimalUnit(e.selected_unit) ? 3 : 0} 
    
                                step={isDecimalUnit(e.selected_unit) ? 0.01 : 1}

                                value={e.entered_qty}
                                defaultValue={e.entered_qty}
                                // max={e.selected_batch.total_stock}
                                onBlur={val => {
                                  let inputQty = parseFloat(val.target.value) || 0; 
                                  if (isDecimalUnit(e.selected_unit)) {
                                      inputQty = parseFloat(inputQty.toFixed(3));
                                    } 
                                    updateQty(e.batch_code, inputQty, e.code);
                                    updateTotal();
                                  // }
                                }}
                                // min={0}
                                size="xs"
                                w={80}
                                ref={element => {
                                  if (selectValue === e.code && focus) {
                                    element?.focus();
                                    element?.select();
                                    setFocus(false);
                                  }
                                  if (
                                    location.pathname.includes("edit") &&
                                    index === invoiceItemsList.length - 1 &&
                                    focusSearch
                                  ) {
                                    setSelectValue(e.code);
                                    setFocus(true);
                                    setfocusSearch(false);
                                  }
                                }}
                                onKeyDown={(event) => {


                                    if (!isDecimalUnit(e.selected_unit) && (event.key === "." || event.key === ",")) {
                                      event.preventDefault();
                                      alert("Decimals are not allowed for PCS/NOS units!");
                                      return;
                                    }
                                  if (event.key === "Enter") {
                                    event.preventDefault(); // Prevents default behavior
                                    event.target.blur(); // Triggers onBlur manually
                                    setTimeout(() => {
                                      qty_ref?.current?.focus(); // Move focus to qty_ref after blur
                                    }, 10);
                                  }
                                  // if (event.key === "F4" || event.key === "F5") {
                                  if (event.key === "F5"&& event.altKey) {
                                    event.preventDefault();
                                    event.target.blur();
                                  }
                                  }}
                                      onChange={(value) => {
                                  if (!isDecimalUnit(e.selected_unit) && value && value.toString().includes('.')) {
                                    // Remove decimal part for non-decimal units
                                    const wholeNumber = Math.floor(value);
                                    setInvoiceItemsList(
                                      produce(draft => {
                                        const item = draft.find(item => item.code === e.code);
                                        if (item) {
                                          item.entered_qty = wholeNumber;
                                          item.qty = wholeNumber;
                                        }
                                      })
                                    );
                                    showErrorToast({
                                      title: "Invalid Input",
                                      message: "Decimal values are not allowed for PCS/NOS units!"
                                    });
                                  } else if (isDecimalUnit(e.selected_unit) && value) {
                            // ✅ FIX: Round to 3 decimal places while typing for KG units
                            const roundedValue = parseFloat(value.toFixed(3));
                            setInvoiceItemsList(
                              produce(draft => {
                                const item = draft.find(item => item.code === e.code);
                                if (item) {
                                  item.entered_qty = roundedValue;
                                  item.qty = roundedValue;
                                }
                              })
                            );
                          }
                        }}
                      />
                    ) : (
                      <Text size="sm" fw={600}>
                        {isDecimalUnit(e.selected_unit) ? 
                          (parseFloat(e.qty || 0).toFixed(2) + "kg") : // ✅ FIXED: toFixed(2) for KG units
                          (e.qty || 0) + " Pcs"
                        }
                      </Text>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {isEditingThisItem && editStep === 'disc' ? (
                      <NumberInput
                        id={`edit_discount_${e.batch_code}`}
                        value={editDiscount}
                        onChange={setEditDiscount}
                        decimalSeparator="."
                        precision={2}
                        step={0.01}
                        min={0}
                        max={100}
                        size="xs"
                        styles={{
                          input: {
                            fontWeight: 'bold',
                            textAlign: 'center'
                          }
                        }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            handleEditEnter();
                          }
                        }}
                      />
                    ) : (
                      <Text size="sm" color={e.discountPercentage > 0 ? "red" : "dimmed"}>
                        {e.discountPercentage > 0 ? `${e.discountPercentage}%` : "0%"}
                      </Text>
                    )}
                  </td>
                  
                  <td width={70} style={{textAlign: 'right'}}>
                    <Text size={"sm"} ml={10}>
                      {e.discount ? Number(e.discount).toFixed(2) : '0.00'}
                    </Text>
                  </td>
          
                  <td style={{textAlign: 'right'}}> {Number(e.total).toFixed(2)}</td>
                  {/* <td style={{ textAlign: "center" }}>
                  <ActionIcon
                    color="orange"
                    size="sm"
                    onClick={() => handleEditItem(e)}
                    disabled={isEditingMode}
                  >
                    <IconEdit size={20} />
                  </ActionIcon>
                </td> */}
                      
                      <td align="center">
                        <ActionIcon
                          color="red"
                          onClick={(event) => {
                  event.stopPropagation(); // Prevent row selection when deleting
                  deleteInvoiceItem(uniqueId);
                }}
                          disabled={isEditingMode}
                        >
                          <IconSquareRoundedMinus
                            style={{
                              width: 20,
                              cursor: "pointer",
                            }}
                          />
                        </ActionIcon>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
                </Table>
              </Box>

               {/* Empty List Alert */}
              {invoiceItemsList.length === 0 && (
                <Alert
                  mt={20}
                  icon={<IconAlertCircle size="1rem" />}
                  title="Invoice list is empty."
                >
                  Click on search box to search invoice item and select it to add to the invoice.
                </Alert>
              )}
           
            </Card>
            {/* ✅ Sticky Footer Bar */}
              <Box style={{
                position: "fixed",
              bottom: 0,
              left: 0,
              width: isMobileScreen ? "100%" : "75%",
              background: "#fff",
              borderTop: "1px solid #ddd",
              zIndex: 20,
              padding: "10px 24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "50px",
              fontSize: "18px",
                fontWeight: 600,
              }}>
              <Breadcrumbs separator="" sx={{ fontSize: 20 }}>
                  Total Item: <Text span fw={600} sx={{ fontSize: 20 }}>{totalItems}</Text>
                  Total Quantity: <Text span fw={600} sx={{ fontSize: 20 }}> {totalPcs > 0 ? `${totalPcs} Pcs` : ""} {totalPcs > 0 && totalKgs > 0 ? ' / ' : ''} {totalKgs > 0 ? `${totalKgs.toFixed(3)} Kgs` : ""}</Text>
                  Total Amount: <Text span fw={600} sx={{ fontSize: 20 }}>₹{totalAmount}</Text>
              </Breadcrumbs>
              </Box>
             </Col>
           

           {/* Right Panel - Invoice Summary */}
          <Col span={isMobileScreen ? 12 : 3}style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}>
            {/* <Stack spacing="xs" style={{
                    flex: 1,
                    overflowY: "auto",
                    paddingBottom: "10px",
                  }}> */}
             {/* Summary Card */}
              <Card style={{ backgroundColor: "#e9edeaff",}}>
                <Text fw={800} mb="xs"size="sm" color="green.7"align="center">
                  <Group spacing="xs">
                    <IconFileInvoice size={14} />
                    Invoice Summary
                  </Group>
                </Text>
                </Card>
                    <Card style={{
                          background: "white", 
                          padding: "10px 14px",
                          borderRadius: "6px",
                          marginBottom: "10px",
                          border: "1px solid #cce3d5",
                          height: "400px",
                        }}>
                <Table withColumnBorders fontSize="sm" cellPadding={2}>
                  <tbody>
                    <tr>
                      <td style={{padding: '4px'}}>Subtotal</td>
                      <td style={{padding: '4px', textAlign: 'right'}}>₹ {(parseFloat(getTotal("subtotal")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{padding: '4px'}}>Tax Total</td>
                      <td style={{padding: '4px', textAlign: 'right'}}>₹ {(parseFloat(getTotal("tax")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{padding: '4px'}}>Total Discount</td>
                      <td style={{padding: '4px', textAlign: 'right'}}>₹ {(parseFloat(getTotal("discount")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{padding: '4px'}}>Packing Charge</td>
                      <td style={{padding: '4px', textAlign: 'right'}}>₹ {(parseFloat(getTotal("packing_charge")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{padding: '4px'}}>Coupon</td>
                      <td style={{padding: '4px', textAlign: 'right'}}>₹ {(parseFloat(getTotal("coupon")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{padding: '4px'}}>Round Off</td>
                      <td style={{padding: '4px', textAlign: 'right'}}>
                        {(() => {
                          const amount = parseFloat(getTotal("amount")) || 0;
                          const rounded = Math.round(amount);
                          const diff = rounded - amount;
                          return diff === 0
                            ? "₹ 0.00"
                            : `₹ ${(diff > 0 ? "+" : "") + diff.toFixed(2)}`;
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <td style={{padding: '4px'}}><strong>Net Total</strong></td>
                      <td style={{padding: '4px', textAlign: 'right'}}>
                        <strong>
                          ₹ {Math.round(parseFloat(getTotal("amount")) || 0).toFixed(2)}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card>

              {/* Action Button */}
              <Card >
                <Button
                  color="green"
                  size="sm"
                  fullWidth
                  onClick={() => {
                    setPayAndPrintBill(true);
                    setTimeout(() => {
                      saveInvoice()
                    }, 100);
                  }}
                  loading={submitInvoice.isLoading}
                >
                  {isEditing ? "Print & Edit Invoice (alt+F5)" : "Print & Save Invoice (alt+F5)"}
                </Button>
              </Card>
            {/* </Stack> */}
          </Col>
        </Grid>
      </Container>
      </Box>
   

      {/* ENDS :: Main content */}

      {/* STARTS : Product Selection Modal */}
      <Modal
        opened={productSelectionModal}
        onClose={() => {
          setProductSelectionModal(false);
        }}
        title={
          <Box px={10}>
            <Text fw={"600"}>Select Batch</Text>
            {selectedProductCode && (
        <Text size="sm" color="dimmed">
          Product: {productsList.find(p => p.code === selectedProductCode)?.label}
        </Text>
          )}
          </Box>
          }
        size={"850px"}
        centered
      >
        <Box pl={10}>
        <Divider />
        </Box>
        <Box px={10} mb={10}>
        <Box mt={20}>
            <Table
              withColumnBorders
              highlightOnHover
              withBorder
              verticalSpacing={"xs"}
              horizontalSpacing={"xs"}
              className="normal-table"
              ref={batchTable}
            >
              <thead>
                <tr>
                  <th> Batch No. </th>
                  <th> Exp. Date </th>
                  <th> No Of Days To Expire </th>
                  {/* <th> Discount Price </th> */}
                  <th> Available Stock</th>
                  <th> Total Stock</th>
                  <th> Selling Price</th>
                  <th> MRP</th>
                  <th></th>
                </tr>
              </thead>
                  <tbody>
              {modalBatches.map(e => {
                const usedInInvoice = invoiceItemsList
                .filter(item => item.batch_code === e.batch_code && item.product_code === e.product_code)
                .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

              const availableStock = Math.max(0, (e.total_stock || 0) - usedInInvoice);
                return (
                  <tr
                    key={e.batch_code}
                    tabIndex={0}
                    style={
                      checkIfBatchAlreadyExists(e.product_code, e.batch_code) || e.stock === 0
                        ? {
                            background: "repeating-linear-gradient( 45deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1) 10px, rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0.2) 20px)",
                            opacity: ".4",
                          }
                        : {}
                    }
                  >
                <td>{e.batch_code}</td>
                <td width={120}> {e.expiry_date} </td>
                <td> {getExpiryDayLeft(e.expiry_date)} </td>
                <td> {Number(availableStock).toFixed(3)} </td>
                <td> {Number(e.total_stock).toFixed(3)} </td>
                <td> {e.price} </td>
                <td> {e.mrp} </td>
                <td>
                <Button
                  onClick={() => {
                    if (isEditingMode) {
                      handleBatchSelectInEdit(e);
                    } else {
                      // For new product selection
                      handleBatchSelect(e);
                    }
                    setProductSelectionModal(false);
                  }}
                  size="xs"
                  disabled={!isEditingMode && (e.stock === 0 || checkIfBatchAlreadyExists(e.product_code, e.batch_code))}
                  color={
                    (editingItem && selectedBatchCode === e.batch_code) ? "green" : "blue"
                  }
                  
                >
                  {(editingItem && selectedBatchCode === e.batch_code) ? "Selected" : "Select"}
                </Button>
              </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Box>
        </Box>
      </Modal>
      {/* ENDS : Product Selection Modal */}

      {paymentReceiptFormVisible && (
        <AddPaymentReceipt
          opened={paymentReceiptFormVisible}
          fromInvoice={true}
          onClose={() => {
            setPaymentReceiptFormVisible(false);
            setPayAndPrintBill(false);
            printInvoice(invoicesData);
          }}
          defaultData={paymentReceiptData}
          invoiceId={paymentReceiptData?.invoice}
        />
      )}

      <CouponsModal
        modalOpened={couponsModalOpened}
        setModalOpened={setCouponsModalOpened}
        setCouponCode={setCouponCode}
        setCouponApplied={setCouponApplied}
      />
    </>
  );
}